/* SINH TỰ ĐỘNG bởi scripts/build-js-bundles.js — ĐỪNG SỬA TAY.
   Sửa file nguồn trong assets/ rồi chạy lại script. */

/* ===== global.js ===== */
function getFocusableElements(container) {
  
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  /* v53: hỏi `open` THẬT — facets.liquid in sẵn open="" cho nhóm lọc 🖥, gán cứng 'false' là báo "thu gọn" cho nhóm đang mở. Gác: scripts/test-nhom-mo-khong-bao-thu-gon.js */
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentElement.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    // BUG minmax polish (2026-06-06): clamp a TYPED value into the product's
    // [min..max] (data-min-qty/data-max-qty — rendered on PDP + cart-line
    // inputs only; other quantity inputs are untouched). Bound on the input
    // itself so it runs at-target, BEFORE any ancestor change handler
    // (cart-items / webi-cart-items) reads the value. Typed 99 with max 5 now
    // lands on 5 (was: snapped back to 1). Typed 0 stays allowed on cart
    // lines (remove path); values below a min>1 clamp UP to the min.
    // 18/8/2026 — AI NẮN SỐ THÌ NGƯỜI ĐÓ PHẢI NÓI.
    //
    // Phép kẹp ngay dưới chạy AT-TARGET nên nó LUÔN THẮNG: tới lúc cart.js:45
    // và product-form.js:75 đọc `event.target.value` (cả hai đều hoãn 300ms)
    // thì con số đã bị nắn xong rồi, điều kiện `typed < minQty` của chúng KHÔNG
    // BAO GIỜ đúng ⇒ hai câu báo ở đó là mã chết trên đường gõ tay. Đo bằng
    // cách chặn setter `value` trên chính ô số lượng của trang giỏ: đúng một
    // lượt ghi "1" (do người gõ) rồi ngay lập tức một lượt ghi "3" từ file này,
    // trong CÙNG một tick.
    //
    // Hậu quả với khách: gõ 1, số nhảy về 3, thành tiền nhảy từ $1.99 lên
    // $5.97 — không một chữ giải thích. Đây đúng là nhóm "tiền nhảy mà không
    // báo" mà cả vòng này đang dọn.
    //
    // Chữ đi qua window.aefTienToiThieu (layout/theme.liquid) — CÙNG MỘT CỬA
    // với cart.js · mini-cart-popup.js · product-form.js, không chép công thức
    // lần thứ tư. Đơn giá đọc từ data-unit-price của chính ô này.
    const baoLuat = (kieu, gioiHan) => {
      const pid = this.input.getAttribute('data-product-id');
      if (!pid) return;
      // Pattern 3: `.show__err--<pid>` render nhiều lần trên một trang (mỗi
      // dòng giỏ, PDP, thẻ SP). Tìm trong khối GẦN NHẤT trước, để câu báo không
      // rơi xuống một thẻ đang khuất ở cuối trang.
      const khoi =
        this.closest('.cart-item') ||
        this.closest('.wbheadcartdrop') ||
        this.closest('.card-wrapper') ||
        this.closest('.product__info-container') ||
        this.closest('.aef-pdp-buy');
      const el = (khoi || document).querySelector('.show__err--' + pid) || document.querySelector('.show__err--' + pid);
      if (!el) return;
      // 18/8/2026 — ĐỪNG NÓI HAI LẦN CÙNG MỘT CÂU.
      // Thẻ SP · PDP · dòng giỏ đều đã có dòng nhắc BỀN cùng nội dung ("Mua tối
      // thiểu 3 · $5.97"). Mở web thấy: gõ sai một cái là PDP hiện đúng câu đó
      // thêm lần nữa ngay trên nó, khác màu — đọc như trang bị lỗi chứ không như
      // một lời giải thích. Nếu luật đã nói rồi thì thôi, chỉ nắn số.
      // Nhánh 'max' vẫn nói: không có dòng nhắc bền nào cho mức trần.
      if (kieu === 'min') {
        // querySelectorAll chứ KHÔNG querySelector — Pattern 3, và đã cắn ngay
        // lần đầu: PDP có HAI dòng .pdp-min-hint, cái ĐẦU nằm trong khối số
        // lượng đang ẩn (offsetParent = null) còn cái đang hiện là cái THỨ HAI.
        // Lấy cái đầu rồi thấy nó ẩn ⇒ tưởng "chưa ai nói" ⇒ nói lặp y như cũ.
        // ⚠️ Và phải hỏi trong ĐÚNG KHỐI của món này, tuyệt đối không hỏi cả
        // trang. Đo trên PDP thật: có 3 dòng nhắc đang hiện, mà 2 trong số đó
        // thuộc dãy "Vừa xem" ở cuối trang, của HAI MÓN KHÁC ("Mua tối thiểu 2
        // · $4.98" và "· $6.00"). Hỏi cả trang là hai món lạ bịt miệng câu báo
        // của món chính. Không xác định được khối thì NÓI — thà thừa một câu
        // còn hơn nắn số của khách mà im.
        if (khoi) {
          const nhac = [...khoi.querySelectorAll('.pdp-min-hint, .cart-item__min-hint, .card__min-hint')];
          if (nhac.some((n) => n.offsetParent !== null && /\d/.test(n.textContent || ''))) return;
          // ⚠️ 27/9/2026 — khái niệm "dòng nhắc bền ĐANG HIỆN" có bản thứ hai ở
          // assets/cart.js noiSanChoO() (dòng giỏ trang /cart sau lượt kéo sàn): hỏi
          // bằng `hidden` + getComputedStyle cả chuỗi tổ tiên, không bằng offsetParent
          // (lý do ghi ở đó). Hai phép lệch nhau ở visibility:hidden và position:fixed
          // — đổi luật một bên thì đổi cả bên kia.
        }
      }
      el.style.display = 'block';
      el.textContent = kieu === 'max'
        ? ((window.aefT ? window.aefT('card.max_tooltip') : 'Max reached') + ' (' + gioiHan + ')')
        : (window.aefTienToiThieu
            ? window.aefTienToiThieu(gioiHan, window.aefGiaDonVi(this.input))
            : (window.aefT ? window.aefT('card.min_hint') : 'Min order:') + ' ' + gioiHan);
    };
    // 🔴 6/9/2026 vòng 43 — NẮN TRƯỚC KHI BÁO, đừng báo rồi mới nắn.
    //
    // Phép kẹp dưới đây trước nay chỉ treo trên sự kiện `change`. Nhưng
    // onButtonClick bắn `change` NGAY SAU stepUp()/stepDown() — tức nó báo ra
    // ngoài con số CHƯA nắn, rồi người nghe at-target mới nắn lại. Tới lượt
    // assets/cart.js:102 đọc `event.target.value` thì con số đã về ĐÚNG CHỖ CŨ:
    // nó vẫn POST /cart/change.js và vẫn thay sạch `.js-contents` cho một thay
    // đổi bằng KHÔNG.
    //
    // Khách gặp thế nào: dòng hàng có mức mua tối thiểu VÀO GIỎ ĐÚNG NGAY Ở SÀN
    // (thẻ SP đẩy qty = min ngay lần thêm đầu), nên "đang ở sàn" là trạng thái
    // MẶC ĐỊNH của 955 SP chứ không phải ca hiếm. Bấm "−" ở đó: lớp phủ quay
    // tròn, bảng giỏ vẽ lại, con số y hệt lúc đầu. Khách tưởng trang hỏng nên
    // bấm lại — mỗi lần một vòng mạng thật.
    //
    // Cách sửa: tách thân phép kẹp ra ĐÚNG MỘT chỗ (`this.napLuat`) rồi cho
    // onButtonClick gọi lại chính nó trước khi so số. Tuyệt đối không chép luật
    // xuống dưới đó lần thứ hai. [[feedback_one_concept_two_sources]]
    //
    // KHÔNG khoá nút "−" ở sàn: Boss đã BỎ kiểu "− khoá cứng" ngày 23/06 và
    // thay bằng thùng rác (assets/card-stepper.js:120-127). Chỗ này chỉ bỏ
    // cú gọi máy chủ vô nghĩa, không đổi thứ khách nhìn thấy.
    // Người gác: scripts/test-nut-tru-o-san-khong-goi-may-chu.js
    this.napLuat = () => {
      if (!this.input) return;
      const minQ = parseInt(this.input.getAttribute('data-min-qty'), 10);
      const maxQ = parseInt(this.input.getAttribute('data-max-qty'), 10);
      const v = parseFloat(this.input.value);
      if (isNaN(v)) return;
      // data-aef-vua-kep-max: /cart vẽ lại cả bảng sau lượt ghi (cart.js) ⇒ câu báo ghi ở đây mất theo;
      // cart.js đọc dấu này để nói lại câu trần trong ĐÚNG dòng sau khi vẽ.
      if (maxQ > 0 && v > maxQ) { this.input.value = String(maxQ); this.input.setAttribute('data-aef-vua-kep-max', String(maxQ)); baoLuat('max', maxQ); }
      else if (minQ > 1 && v > 0 && v < minQ) { this.input.value = String(minQ); baoLuat('min', minQ); }
    };
    if (this.input) {
      this.input.addEventListener('change', this.napLuat);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    /* 🔴 24/10/2026 (min-max theo BIẾN THỂ, plan C1) — TRẦN CỦA CHÍNH Ô NÀY, không của SP.
       Bản cũ tra `.hidden__temp--<product.id>` trên CẢ TRANG ⇒ hai dòng giỏ cùng SP (thùng
       trần 1 · lẻ trần 12) dùng chung trần của dòng ĐẦU. Máy chủ in trần của đúng dòng / biến
       thể lên chính ô số lượng: `data-max-qty` (giỏ · PDP — 0 = không trần), hoặc `max=`
       (ô không mang data-max-qty: xem nhanh, form ẩn của thẻ). PDP/thẻ ghi lại hai thuộc tính
       này khi khách đổi quy cách (main-product syncVariant · khối bảng giá của thẻ ở dưới). */
    const maxDl = parseInt(this.input.getAttribute('data-max-qty'), 10);
    const maxThuocTinh = parseInt(this.input.getAttribute('max'), 10);
    const maxSo = this.input.hasAttribute('data-max-qty') ? maxDl : maxThuocTinh;
    const maxQuantity = maxSo > 0 ? String(maxSo) : '';
    const maxQuantityFormat = parseFloat(maxQuantity);
    const valueFormat = parseFloat(previousValue);

    const btnPlus = this.querySelector('button[name="plus"]');

    if (event.target.name === 'plus') {
      this.input.stepUp();
      if (maxQuantity && valueFormat + 1 >= maxQuantityFormat && btnPlus) {
        btnPlus.setAttribute('disabled', true);
        btnPlus.style.cursor = 'not-allowed';
        btnPlus.setAttribute('data-toggle', 'tooltip');
        // BUG minmax polish (2026-06-06): tooltip through the aefT i18n bridge
        // (ae-delivery-widget.js) so it follows ae_lang — was hardcoded EN.
        btnPlus.setAttribute('title', (window.aefT ? window.aefT('card.max_tooltip') : 'Max reached') + ` (${maxQuantityFormat})`);
      }
    } else if (event.target.name === 'minus') {
      this.input.stepDown();
      if (maxQuantity && valueFormat - 1 < maxQuantityFormat && btnPlus) {
        btnPlus.removeAttribute('disabled');
        btnPlus.removeAttribute('data-toggle');
        btnPlus.removeAttribute('title');
        btnPlus.style.cursor = 'pointer';
      }
    }

    // Nắn TRƯỚC khi báo — xem chú thích trong constructor. Nếu phép kẹp kéo con
    // số về đúng chỗ cũ thì cú bấm này KHÔNG đổi được gì, và một cú bấm không
    // đổi được gì thì không được bắt máy chủ vẽ lại cả bảng giỏ.
    if (this.napLuat) this.napLuat();

    // Fire a NEW change event each time — Event objects can only be dispatched once per spec.
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const modalCloseBtn = this.querySelector('[id^="ModalClose-"]');
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', this.hide.bind(this));
    
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // 01/11/2026: ô slide điện thoại rộng đúng khung (360) nhưng bước có thêm khe (376) nên phép
    // chia ra 0 và bộ đếm in n+1: 8 ảnh ghi "1/9". Mỗi trang luôn có ít nhất một ô.
    this.slidesPerPage = Math.max(1, Math.floor(this.slider.clientWidth / this.sliderItemOffset));
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSku();
      this.updateStockCountdown();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSku() {
    
    if (!this.currentVariant) return;
    let productMain = this.closest('.product');
    if (productMain && productMain.querySelector('.variant-sku') != null) {
      productMain.querySelector('.variant-sku').innerHTML = this.currentVariant.sku;
    }
  }

  updateStockCountdown() {
    
    if (!this.currentVariant) return;
    let productMain = this.closest('.card,.product');
    if (productMain && productMain.querySelector('.wbstockcount') != null) {
      let variantsData = JSON.parse(productMain.querySelector('#product-variants').innerHTML);
      let stockCountdownConfig = JSON.parse(productMain.querySelector('#product-stock-countdown-config').innerHTML);
      let variant = this.currentVariant;
      if (variantsData[variant.id] > 0 && variant.inventory_management == 'shopify') {
        productMain.querySelector('.wbstockcount').classList.remove('hidden');
        let countdownWrapper = productMain.querySelector('.wbstockcount');
        /* 🔴 23/8/2026 (vòng 25) — đường ĐỔI BIẾN THỂ phải im về con số y như đường máy chủ.
           Vá mỗi Liquid là khách đổi pack một cái, con số 899 quay lại ngay.
           Câu dự phòng để CỨNG và KHÔNG CÓ SỐ: nếu config cũ (đã nằm trong cache trình
           duyệt) thiếu khoá mới, lùi về 'instock_message' là in số trở lại — tức bản vá
           tự mở lại đúng cái lỗ nó bịt. */
        var aefBar = countdownWrapper.querySelector('.wbstockinfo-probar');
        var aefRong = Math.min(100, (variantsData[variant.id] * 100) / stockCountdownConfig.max_stock);
        if (variantsData[variant.id] > stockCountdownConfig.limited_stock_cut_off) { // High Stock
          countdownWrapper.querySelector('.wbstockinfo').classList.replace('wbstockinfo_low', 'wbstockinfo_high');
          countdownWrapper.querySelector('.wbstockinfo').textContent =
            stockCountdownConfig.instock_message_high || 'In stock, ready to be shipped';
          aefBar.style.width = aefRong + '%';
        } else { // Low Stock
          countdownWrapper.querySelector('.wbstockinfo').classList.replace('wbstockinfo_high', 'wbstockinfo_low');
          countdownWrapper.querySelector('.wbstockinfo').innerHTML = stockCountdownConfig.limited_stock_message.replace('{stock_number}', variantsData[variant.id]);
          aefBar.style.width = aefRong + '%';
        }
      } else {
        productMain.querySelector('.wbstockcount').classList.add('hidden');
      }
    }
  }

  updateMedia() {
    
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // Webibazaar Variant in Product Card
    if (this.dataset.layout == 'card') {
      const card = this.closest('.card');
      const newMedia = card.querySelector(
        `[data-media-id="${this.dataset.section}-${this.dataset.product}-${this.currentVariant.featured_media.id}"]`
      );
      if (!newMedia) return;
      const modalContent = card.querySelector('.card__media');
      //const modalContent = document.querySelector(`#webipro-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`);
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      parent.prepend(newMedia);
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    } else {
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    
    // Webibazaar Variant in Product Card
    if (this.dataset.layout == 'card') {
      /* Cùng bản vá 29/8: mọi `querySelector` ở nhánh THẺ đều phải hỏi lại kết quả.
         Nhánh này chạy theo thứ tự "gán biến thể TRƯỚC, vẽ giá SAU", nên bất cứ
         chỗ nào ném ở giữa cũng để lại đúng cái trạng thái nguy hiểm: form đã trỏ
         biến thể mới, mặt thẻ vẫn là biến thể cũ. Ngã sớm còn đỡ hơn ngã giữa. */
      const card = this.closest('.card');
      if (!card) return;
      const productForms = card.querySelectorAll(`#ProductInfo-${this.dataset.section}-${this.dataset.product}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;

        /* 4/9/2026 (vòng 40, bản vá #5) — KHOÁ THỨ HAI CỦA CÙNG MỘT THẺ.
           `.wbproduct-container[data-variant-id]` do máy chủ đóng dấu MỘT LẦN bằng
           `card_default_variant.id` (product-card.liquid:162) và trước bản vá này
           không ai cập nhật. Hai file ĐỌC nó làm khoá:
             · assets/card-stepper.js:330 + :465 — nút "+"/"−" thao tác lên vid này
             · assets/cart-card-indicator.js:34  — huy hiệu "đang có trong giỏ"
           Đo trên staging (thẻ Highlands ở /search): đổi sang "pack of 24" thì ô
           `id` của form thành 49178244448562 còn data-variant-id vẫn ở
           49178244383026 — hai khoá LỆCH. Thêm vào giỏ xong, thẻ báo
           `in-cart=false`, huy hiệu rỗng, nên ô tăng-giảm không hiện: khách vừa
           thêm hàng từ chính cái thẻ ấy mà thẻ nói chưa có gì, và mất luôn đường
           sửa số ngay tại chỗ. Nguy hơn: nếu quy cách MẶC ĐỊNH đang nằm trong giỏ
           thì thẻ khoe số của quy cách khách KHÔNG chọn (HARD GATE Pattern 4).

           Một khái niệm — "thẻ này đang bán biến thể nào" — chỉ được có MỘT câu
           trả lời. Ghi cùng lúc với ô `id`, đúng chỗ danh tính được xác lập, để
           hai khoá không bao giờ trôi khỏi nhau. [[feedback_one_concept_two_sources]]

           Thẻ đóng dấu khoá này ở HAI nơi (product-card.liquid:162 lớp bọc và
           :453 khối tăng-giảm). Khối tăng-giảm dùng nó làm KHOÁ HẸN GIỜ cho
           tooltip và cho nhịp tự thu gọn (card-stepper.js:206 · :425) — để cũ thì
           hai thẻ khác nhau có thể dùng chung một khoá và huỷ hẹn giờ của nhau.
           Chỉ ghi lên ĐÚNG những chỗ hai file kia tra cứu — `.wbproduct-container`
           và `[data-aef-stepper-host]` (HOST_SEL của card-stepper.js:68) cùng
           chính khối `[data-card-stepper]`. Quét bừa mọi `[data-variant-id]` bên
           trong thẻ là ghi đè cả những id hợp lệ của phần tử khác. */
        const O_THE = '.wbproduct-container[data-variant-id], [data-aef-stepper-host][data-variant-id], [data-card-stepper][data-variant-id]';
        const chuThe = [];
        const them = (e) => { if (e && chuThe.indexOf(e) < 0) chuThe.push(e); };
        them(card.closest('.wbproduct-container'));
        if (card.matches(O_THE)) them(card);
        card.querySelectorAll(O_THE).forEach(them);
        chuThe.forEach((e) => e.setAttribute('data-variant-id', String(this.currentVariant.id)));

        /* 🔴 14/9/2026 (vòng 48, phát hiện the-sp-stepper-2) — KHOÁ THỨ BA CỦA CÙNG
           MỘT THẺ: TRẦN TỒN KHO. Hai vòng trước đã kéo `data-variant-id` (vòng 40)
           rồi `data-min-qty` (vòng 40 bản vá #4) đi theo quy cách, nhưng cả ba lượt
           sửa đều đi ngang `data-stock-qty` mà không ai nhìn sang. Trang chi tiết
           thì NHỚ: sections/main-product.liquid:2794 ghi lại thuộc tính này mỗi lần
           đổi quy cách. Thẻ QUÊN. Đúng họ "một khái niệm, hai nguồn dữ liệu".
           [[feedback_one_concept_two_sources]]

           Ai đọc: assets/card-stepper.js:93 (`rulesFor`) lấy đúng thuộc tính này
           trên chính `.wbproduct-container[data-variant-id]` mà khối trên vừa đổi
           khoá, rồi tính trần hiệu dụng `min(trần mua, tồn kho)` và chọn câu bong
           bóng "Chỉ còn N trong kho" (card-stepper.js:89 · :194 · :244).

           Dựng lại trên markup THẬT của LIVE (curl /search?q=indomie ngày 14/9 →
           734.502 byte, 22 thẻ mang data-stock-qty, 6 thẻ đổi được quy cách) nạp
           vào jsdom rồi bắn `change` lên radio — 6/6 thẻ GIỮ NGUYÊN số cũ:
             indomie-chicken-curry-…-5-packs
               TRƯỚC: vid=47242024419634 min=4 STOCK=977
               SAU  : vid=47242023141682 ✅ min=1 ✅  STOCK=977 ❌ đứng im
             Tồn THẬT (Admin API): "1 count" = 977 · "pack of 5" = 994.
           Thẻ indomie-mi-goreng cùng trang mang data-stock-qty="0" ⇒ đổi sang quy
           cách CÒN hàng thì `rules.max = 0 · stockCapped = true`, nút "+" bị từ
           chối VĨNH VIỄN kèm câu "Only 0 in stock" — chặn đúng một đơn hàng bằng
           một con số của quy cách khác.

           ⚠️ CON SỐ PHẢI DO MÁY CHỦ TÍNH. Công thức "tồn kho này có được khoe
           không" đã có NGUỒN DUY NHẤT ở snippets/aef-ton-kho-khoe-duoc.liquid sau
           khi đội soi đếm được BỐN bản chép tay; tính lại bằng JS là đẻ bản thứ
           năm. JSON biến thể của Shopify KHÔNG chở `inventory_quantity` lẫn
           `inventory_policy` nên JS cũng KHÔNG có đường tự biết.

           Nên ở đây làm đúng hai việc, theo nhịp XOÁ-RỒI-GHI:
             ① XOÁ ngay tại chỗ danh tính đổi: đặt về `-1` = "không có trần tồn"
                (card-stepper.js:96 `if (!(stock >= 0)) stock = -1`). Trần cũ là
                trần của quy cách CŨ — giữ lại là nói dối, mà nói dối theo cả hai
                chiều: chặn oan khi tồn mới cao hơn, và vẽ số lạc quan khi tồn mới
                thấp hơn. Máy chủ vẫn chặn thật ở /cart/change.js, nên bỏ trần
                phía khách chỉ mất lớp giữ-cho-số-đừng-trôi, không mất bảo đảm.
             ② GHI số thật ở khối bảng giá bên dưới, khi `<option>` chở sẵn
                `data-ton` — y khuôn `data-min` / `data-mintotal`.

           🔴 NỢ CÒN LẠI (không thuộc file này): snippets/product-card.liquid chưa
           in `data-ton` lên `<option>` (mới có data-min · data-mintotal · data-price
           · data-cprice · data-unitprice · data-unitvalue · data-v-title). Chừng
           nào chưa có, ① chạy một mình và thẻ mất trần tồn sau cú đổi quy cách —
           vẫn tốt hơn mang trần của quy cách khác. Chỉ ghi lên đúng những phần tử
           máy chủ đã đóng dấu thuộc tính này; KHÔNG quét
           `the.querySelectorAll('[data-stock-qty]')` như khối min-qty bên dưới vì
           ở thẻ tập đó RỖNG (product-card.liquid chỉ in nó trên lớp bọc :193). */
        const chuTon = chuThe.filter((e) => e.hasAttribute('data-stock-qty'));
        chuTon.forEach((e) => e.setAttribute('data-stock-qty', '-1'));

        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach(function (option) {
          Array.from(option.querySelectorAll('label')).find((element) => element.classList.remove('active'));
        });

        this.options.forEach(function (option) {
          /* `find` ở trên trả về undefined khi không khớp — vô hại. Còn dòng này
             trước đây gọi thẳng `.classList` trên kết quả có thể null. */
          const o = productForm.querySelector(`[data-val="${option}"]`);
          if (o) o.classList.add('active');
        });
        // const productData = this.getVariantData();
        // const selectVariant = productData.find(e => e.id === this.currentVariant.id);
        // if (selectVariant) {
        //   const priceEl = card.querySelector('.price'); 
        //   priceEl.querySelector('.price-item.price-item--regular').innerHTML = selectVariant.price;
        //   priceEl.querySelector('.price-item.price-item--sale').innerHTML = selectVariant.price;
        //   if (selectVariant.compare_at_price != null) {
        //     priceEl.classList.add('price--on-sale');
        //     priceEl.querySelector('.price__sale').querySelector('.price-item.price-item--regular').innerHTML = selectVariant.compare_at_price;
        //   } else {
        //     priceEl.classList.remove('price--on-sale'); 
        //   }
        // }

        /* 🔴 29/8/2026 — ĐỔI QUY CÁCH TRÊN THẺ: KHÁCH THẤY MỘT GIÁ, GIỎ NHẬN GIÁ KHÁC.
           Bản cũ ném `TypeError: Cannot set properties of null (setting 'innerHTML')`
           NGAY GIỮA CHỪNG, và vì `input[name="id"]` đã được gán Ở TRÊN còn phần vẽ
           giá thì chết, thẻ giữ nguyên giá CŨ trong khi nút mua đã trỏ biến thể MỚI.

           Dựng lại trên staging (Playwright, khổ 1440×900, /search?q=indomie):
             Indomie Hot & Spicy — "1 count" $1.00 · "pack of 5" $4.50 (gạch $4.99)
             trước khi bấm : khách thấy $1.00 · form giữ 47304951890226
             bấm "pack of 5": khách VẪN thấy $1.00 · form đã sang 47304973025586
                              + PAGEERROR "Cannot set properties of null"
           ⇒ bấm thêm là giỏ nhận món $4.50 trong khi thẻ ghi $1.00. Lệch $3,50,
           gấp 4,5 lần con số đang hiện. Cùng họ với vụ lệch $35,50 của vòng 28.

           BỐN CHỖ NÉM, đều là "querySelector trả null mà không ai hỏi lại":
           1. `salePrice` = `.price__sale .price-item--regular` — đó là thẻ <s> gạch
              ngang, mà `snippets/price.liquid` CHỈ in nó khi biến thể ĐANG hiện của
              thẻ có compare_at > price. Thẻ mặc định không giảm giá ⇒ <s> không tồn
              tại ⇒ chọn đúng cái quy cách đang giảm là nổ. Đo trên kho: 3 SP dính
              (mae-ploy-sweet-chili-sauce · safoco-rice-macaroni · indomie-hot-spicy).
           2. `.cardunitp` / `.cardunitv` — hai lớp này KHÔNG TỒN TẠI trong bất kỳ
              markup nào của repo, chỉ có trong chính file này. Hôm nay chưa nổ vì
              không SKU nào bật đơn giá (đã hỏi Admin API: 0/2.000 biến thể có
              `unitPriceMeasurement.referenceUnit`) — mìn hẹn giờ, bật đơn giá cho
              một món là vỡ.
           3. `this.closest('.grid__item')` — thẻ nằm ngoài `.grid__item` (dãy cuộn
              ngang, "vừa xem", gợi ý) thì null ngay từ dòng đầu.
           4. `regularPrice` cũng có thể null theo cùng kiểu.

           VÀ MỘT LỖI NGHĨA: nhánh đơn giá cũ `add("price--on-sale")` — đơn giá KHÔNG
           phải là đang giảm giá; nó bật nhầm khối gạch ngang.

           Vá theo hướng "vẽ đủ cả hai khối rồi mới chọn khối nào hiện", để dù CSS
           đổi hay thiếu node thì con số khách thấy vẫn là con số của biến thể đang
           chọn. Thiếu thẻ <s> thì DỰNG nó, đúng hình dạng price.liquid in ra. */
        const the = this.closest('.card') || this.closest('.grid__item');
        const khungGia = the ? the.querySelector('.price') : null;
        const optionData = the ? the.querySelectorAll('select option') : [];
        const q = (sel) => (khungGia ? khungGia.querySelector(sel) : null);

        optionData.forEach((data) => {
          if (data.value != this.currentVariant.id) return;
          if (!khungGia) return;

          const gia = data.dataset.price || '';
          const giaGach = data.dataset.cprice || '';
          const dangGiam = giaGach !== '';

          /* Cả HAI khối đều mang giá của biến thể đang chọn. Khối nào hiện là do
             lớp `price--on-sale` quyết định, nên không còn cửa cho "khối đang hiện
             giữ số cũ". */
          const oThuong = q('.price__container .price__regular .price-item--regular');
          const oSale = q('.price__container .price__sale .price-item--sale');
          if (oThuong) oThuong.innerHTML = gia;
          if (oSale) oSale.innerHTML = gia;

          if (dangGiam) {
            let oGach = q('.price__container .price__sale .price-item--regular');
            if (!oGach) {
              /* dựng lại đúng hình dạng snippets/price.liquid, kèm nhãn cho trình
                 đọc màn hình — thiếu nó thì người dùng trình đọc nghe hai con số
                 liền nhau mà không biết cái nào là giá gạch. */
              const khoiSale = q('.price__container .price__sale');
              if (khoiSale) {
                const nhan = document.createElement('span');
                nhan.className = 'visually-hidden visually-hidden--inline';
                nhan.setAttribute('data-i18n', 'price.regular_sr');
                nhan.textContent = (window.aefT && window.aefT('price.regular_sr')) || 'Regular price';
                const boc = document.createElement('span');
                oGach = document.createElement('s');
                oGach.className = 'price-item price-item--regular';
                boc.appendChild(oGach);
                khoiSale.appendChild(nhan);
                khoiSale.appendChild(boc);
              }
            }
            if (oGach) oGach.innerHTML = giaGach;
            khungGia.classList.add('price--on-sale');
          } else {
            khungGia.classList.remove('price--on-sale');
          }

          /* Đơn giá: chỉ ghi khi node CÓ THẬT, và KHÔNG đụng `price--on-sale`. */
          const oDonGia = q('.price__container .unit-price .cardunitp');
          const oDonVi = q('.price__container .unit-price .cardunitv');
          if (oDonGia && data.dataset.unitprice) oDonGia.innerHTML = data.dataset.unitprice;
          if (oDonVi && data.dataset.unitvalue) oDonVi.innerHTML = data.dataset.unitvalue;

          /* 4/9/2026 (vòng 40, bản vá #4) — SỐ MUA TỐI THIỂU PHẢI ĐI THEO QUY CÁCH.
             Đo được trên staging: thẻ Highlands, đổi "1 can" $2,49 (min 2) sang
             "pack of 24" $44,99 (min 1) thì giỏ nhận 2 × $44,99 = $89,98 — dư
             $44,99 mỗi lần bấm — vì `card_min_qty` do máy chủ tính MỘT LẦN cho biến
             thể mặc định rồi đóng đinh vào 5 chỗ: [data-min-qty] trên thẻ, trên ô
             tăng-giảm, `min` và `value` của ô số lượng, và chữ "Min order".

             MỘT NGUỒN: con số và cả THÀNH TIỀN đều do máy chủ tính sẵn cho từng
             biến thể (`data-min` / `data-mintotal` trên chính bảng giá này). Ở đây
             chỉ ĐỌC rồi ghi ra 5 chỗ; không có bậc giá nào được tính lại bằng JS. */
          const soMin = parseInt(data.dataset.min || '', 10);
          if (soMin >= 1) {
            the.setAttribute('data-min-qty', String(soMin));
            the.querySelectorAll('[data-min-qty]').forEach((e) => e.setAttribute('data-min-qty', String(soMin)));

            const oSl = the.querySelector('input[name="quantity"]');
            if (oSl) {
              /* Chỉ kéo số lượng theo khi khách CHƯA tự sửa (đang đúng bằng min cũ),
                 hoặc khi số đang giữ đã TỤT DƯỚI mức bắt buộc mới. Khách gõ 10 rồi
                 đổi quy cách mà bị kéo về 1 thì đó là mất thao tác của người ta. */
              const minCu = parseInt(oSl.getAttribute('min') || '1', 10);
              const dangGiu = parseInt(oSl.value || '', 10);
              oSl.setAttribute('min', String(soMin));
              if (!(dangGiu >= 1) || dangGiu === minCu || dangGiu < soMin) oSl.value = String(soMin);
            }

            /* Chữ "Min order: N · $X". Liquid chỉ vẽ nó khi min > 1, nên đổi từ
               quy cách min=1 sang min>1 là KHÔNG CÓ node để sửa — phải dựng, đúng
               hình dạng snippets/product-card.liquid in ra. Cùng lý do với khối <s>
               ở trên: thà dựng lại đúng hình dạng còn hơn để khách đọc số cũ.
               ⚠️ Con số nằm ở node ANH EM của [data-i18n], KHÔNG nằm bên trong —
               applyTranslations ghi đè textContent của span ấy (BUG-J). */
            let nhan = the.querySelector('.card__min-hint');
            if (soMin > 1) {
              if (!nhan) {
                const neo = the.querySelector('.aef-card-sold, .card-price-rating-slot .price');
                nhan = document.createElement('span');
                nhan.className = 'card__min-hint';
                const chu = document.createElement('span');
                chu.setAttribute('data-i18n', 'card.min_hint');
                chu.textContent = (window.aefT && window.aefT('card.min_hint')) || 'Min order:';
                const tien = document.createElement('span');
                tien.className = 'card__min-total';
                nhan.appendChild(chu);
                nhan.appendChild(document.createTextNode(' ' + soMin + ' · '));
                nhan.appendChild(tien);
                if (neo && neo.parentNode) neo.parentNode.insertBefore(nhan, neo);
              }
              const tien = nhan.querySelector('.card__min-total');
              if (tien && data.dataset.mintotal) tien.textContent = data.dataset.mintotal;
              /* node văn bản giữa nhãn và số tiền là chỗ giữ con số */
              for (const nut of nhan.childNodes) {
                if (nut.nodeType === 3 && /\d/.test(nut.nodeValue)) { nut.nodeValue = ' ' + soMin + ' · '; break; }
              }
              nhan.hidden = false;
            } else if (nhan) {
              nhan.hidden = true;
            }
          }

          /* 14/9/2026 (vòng 48, the-sp-stepper-2) — VIỆC ② của khối xoá-rồi-ghi ở
             trên: trần tồn kho THẬT của quy cách vừa chọn, do MÁY CHỦ tính sẵn và
             chở trên chính bảng giá này (`data-ton`, y khuôn `data-min`). Chỉ số
             `>= 0` mới là trần; `-1` là "không được khoe" và cũng chính là giá trị
             ① vừa đặt, nên không cần ghi lại. Thiếu thuộc tính ⇒ giữ nguyên `-1`:
             thà KHÔNG có trần phía khách (máy chủ vẫn chặn) còn hơn mang trần của
             quy cách khác. Tuyệt đối không suy ra tồn kho từ `disabled` của
             `<option>` — đó là `variant.available`, một câu hỏi khác, và chép nó
             thành trần là đẻ công thức thứ năm. */
          const soTon = parseInt(data.dataset.ton || '', 10);
          if (soTon >= 0) {
            chuTon.forEach((e) => e.setAttribute('data-stock-qty', String(soTon)));
          }

          /* 🔴 24/10/2026 (min-max theo BIẾN THỂ, plan N3) — TRẦN MUA ĐI THEO QUY CÁCH.
             Trần nay đặt riêng từng quy cách (thùng 1 · lẻ 12). Thẻ in trần của biến thể
             MẶC ĐỊNH một lần; khách đổi sang quy cách khác mà trần đứng im là chặn oan (lẻ
             bị kẹp ở 1) hoặc thả lỏng (thùng thêm được 12). Một nguồn: máy chủ giải trần
             từng biến thể vào `data-max` của chính bảng giá (snippets/product-card.liquid,
             snippets/aef-tran-mua.liquid). Ở đây chỉ ĐỌC rồi ghi đúng chỗ mà hai người đọc
             tra: gốc thẻ + [data-max-qty] bên trong (card-stepper.js rulesFor ·
             aef-cart-drawer.js xetTran) và `max` của ô số lượng (QuantityInput). 0 = không
             trần ⇒ gỡ `max`. Thiếu `data-max` (HTML cũ) ⇒ không đụng gì.
             25/10 (/code-review, làn min-max-2): + `.hidden__temp--<id SP>` của CHÍNH thẻ này
             (product-form.js đọc nó khi bấm thêm) — trống = không trần, y như máy chủ in. Chỉ
             trong `the`: span cùng SP ở thẻ/khối khác không phải của thẻ này. */
          if (data.hasAttribute('data-max')) {
            const soMax = parseInt(data.getAttribute('data-max') || '', 10);
            const mx = soMax > 0 ? String(soMax) : '0';
            the.setAttribute('data-max-qty', mx);
            the.querySelectorAll('[data-max-qty]').forEach((e) => e.setAttribute('data-max-qty', mx));
            the.querySelectorAll('input[name="quantity"]').forEach((e) => {
              if (soMax > 0) e.setAttribute('max', mx); else e.removeAttribute('max');
            });
            if (this.dataset.product) {
              the.querySelectorAll('.hidden__temp--' + this.dataset.product).forEach((e) => { e.textContent = soMax > 0 ? mx : ''; });
            }
          }
        });

      });
      return;
    }

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  /* 23/8/2026 — MỘT CÂU cho khách khi lượt tải biến thể hỏng. Đặt cạnh khối giá
     (chứ không cạnh nút) vì đó là chỗ mắt đang nhìn khi vừa bấm đổi biến thể.
     Dùng lại khoá i18n có sẵn `facets.err_load` — không đẻ chuỗi thứ hai. */
  /* 🔴 25/9/2026 (vòng 53) — HỘP NÀY CÓ HAI CHỖ HỞ, nay đều vá:
     (1) nó là ANH EM đứng trước #price-, không nằm trong khối giá, nên lệnh chép
         ruột ở nhánh thành công không quét nó đi, và trước đây không ai gỡ ⇒ một
         lượt hỏng là hộp đỏ nằm lại tới khi tải lại trang, cạnh giá đã hiện đúng
         và nút mua đã mở. Nhánh thành công của renderProductInfo nay gỡ nó.
     (2) chữ bị đóng băng theo ngôn ngữ lúc tạo (box.textContent, không data-i18n)
         ⇒ đổi EN/VI lúc đang chạy không lật. Nay chữ nằm trong span con mang
         data-i18n; "⚠️ " là node anh em để bộ dịch không xoá nó. ĐỪNG ghi
         textContent lên chính hộp nữa — ghi thế là xoá mất span mang khoá dịch.
     Người gác: scripts/test-hop-loi-bien-the-tu-go.js */
  baoLoiTaiBienThe() {
    const neo = document.getElementById(`price-${this.dataset.section}`);
    if (!neo || !neo.parentNode) return;
    const t = (window.aefT && window.aefT('facets.err_load')) || "Couldn't load — please try again";
    let box = document.getElementById('aef-variant-err');
    if (!box) {
      box = document.createElement('p');
      box.id = 'aef-variant-err';
      box.setAttribute('role', 'status');
      box.style.cssText = 'margin:8px 0;padding:8px 12px;border-radius:8px;background:#fdecea;color:#a3261a;font-weight:600;font-size:13px';
      box.appendChild(document.createTextNode('⚠️ '));
      const chuMoi = document.createElement('span');
      chuMoi.setAttribute('data-i18n', 'facets.err_load');
      box.appendChild(chuMoi);
      neo.parentNode.insertBefore(box, neo);
    }
    const chu = box.querySelector('[data-i18n="facets.err_load"]');
    if (chu) chu.textContent = t;
  }

  renderProductInfo() {
    
    // Webibazaar Variant in Product Card
    if (this.dataset.layout == 'card') {
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      return;
    }
    /* 🔴 23/8/2026 (vòng 25) — TRƯỚC ĐÂY CHUỖI NÀY KHÔNG CÓ .catch VÀ KHÔNG XÉT
       response.ok. onVariantChange() đã gọi toggleAddButton(true,'',false) để KHOÁ
       nút mua trước khi bắn fetch, và chỉ nhánh .then thành công mới gỡ khoá ra.
       Nên mạng rớt đúng lúc đổi biến thể là:
           nút mua disabled = TRUE, vĩnh viễn (đo tiếp +3,8 giây: vẫn true)
           giá trên trang VẪN là giá biến thể CŨ
           URL đã đổi sang ?variant=<mới>  ⇒ chữ và số không còn khớp nhau
           không một lời nào cho khách
       Giống hệt nhau ở 📱 390×844 và 🖥 1440×900.
       Đây KHÔNG phải chủ ý: facets.js:179-196 đã có sẵn đúng khuôn xử lý — chỉ là
       chỗ này chưa chép theo. */
    /* 🔴 25/9/2026 (vòng 53) — PHẢN HỒI CŨ VỀ SAU GHI ĐÈ KHỐI GIÁ.
       Radio, ?variant= và input[name="id"] đổi ĐỒNG BỘ lúc bấm; chỉ khối giá đi
       theo mạng. Mỗi cú đổi bắn một fetch riêng, không huỷ lượt trước, nên lượt
       nào về SAU CÙNG thì thắng. Đo trên LIVE (LKK 18 oz $9.99 / 32 oz $20.99):
       bấm 32→18→32, lượt 18 về sau ⇒ form = 32 oz mà khối giá + thanh dính đáy
       in $9.99. HARD GATE Pattern 4: giá · URL · chip · form phải cùng MỘT gói.
       Vá: đánh số lượt; chỉ lượt MỚI NHẤT, và còn đúng gói đang chọn, được đụng
       DOM — ở CẢ .then lẫn .catch (lượt cũ hỏng không được ẩn giá đúng / bật hộp
       lỗi). Lượt bị bỏ qua không mở khoá nút: lượt cuối luôn tới .then hoặc
       .catch và tự mở. So id là cho nhánh setUnavailable (currentVariant rỗng,
       không bắn lượt mới). Người gác: test-doi-bien-the-phan-hoi-cu-khong-de-gia.js */
    const xin = this.currentVariant.id;
    const luot = (this._aefLuotGia = (this._aefLuotGia || 0) + 1);
    const conLaLuotMoi = () => luot === this._aefLuotGia && !!this.currentVariant && this.currentVariant.id === xin;
    /* 🔴 25/9/2026 (vòng 53, code-pdp-collection-search#6) — XIN SECTION NHỎ, ĐỪNG
       XIN NGUYÊN PDP. Trước đây mọi cú đổi quy cách xin lại cả section chính:
       đo LIVE 25/9 là 52.601 B brotli / 182.154 ký tự, DOMParser đọc trọn trên
       luồng chính, chỉ để chép 992 ký tự của #price-… — và nút mua khoá suốt lượt
       chờ ấy. PDP chính nay khai `data-price-section="aef-pdp-gia"`: section nhỏ gọi
       theo tên file, vẽ ĐÚNG snippet ruột khối giá mà máy chủ vẽ lúc tải trang
       (snippets/aef-pdp-khoi-gia.liquid) ⇒ cùng một nguồn giá, chỉ bớt byte.
       ⛔ Đường mới CỘNG THÊM, không thay đường cũ: section nhỏ hỏng (404 vì Shopify
       lặng lẽ từ chối file, mạng rớt, hay 200 mà thiếu #price-<tên>) thì lui về xin
       nguyên section chính như trước — chậm hơn, không bao giờ sai hơn. Chỉ khi
       CẢ HAI hỏng mới rơi xuống .catch (ẩn giá + báo lỗi, thiết kế vòng 25).
       Không khai (xem nhanh, featured-product) ⇒ đi đường cũ y nguyên, kể cả chuyện
       200-mà-thiếu-khối-giá vẫn chỉ là "không đổi ruột". Lượt đã cũ thì không lui,
       không phân tích. Người gác: scripts/test-doi-quy-cach-xin-khoi-gia-nho.js */
    const secChinh = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const secGia = this.dataset.priceSection;
    const layKhoiGia = (sec, batBuoc) => fetch(`${this.dataset.url}?variant=${xin}&section_id=${sec}`)
      .then((response) => {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then((responseText) => {
        if (!conLaLuotMoi()) return null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const khoi = html.getElementById(`price-${sec}`);
        if (!khoi && batBuoc) throw new Error('thiếu #price-' + sec);
        return khoi;
      });
    (secGia
      ? layKhoiGia(secGia, true).catch(() => (conLaLuotMoi() ? layKhoiGia(secChinh, false) : null))
      : layKhoiGia(secChinh, false))
      .then((source) => {
        if (!conLaLuotMoi()) return;
        const destination = document.getElementById(`price-${this.dataset.section}`);

        /* 🔴 24/8/2026 — KHỐI GIÁ LẬT VỀ TIẾNG ANH SAU CÚ ĐỔI QUY CÁCH ĐẦU TIÊN.

           Dòng `innerHTML` ngay dưới thay TOÀN BỘ ruột khối giá bằng HTML mới
           lấy từ máy chủ. HTML đó là bản chưa dịch — máy chủ luôn gửi lang="en"
           (tiệm này không nối locale native của Shopify), chữ tiếng Việt do
           từ điển JS vẽ lên sau. Thay ruột xong mà không gọi lại bộ dịch thì
           mọi node `data-i18n` vừa bơm vào nằm trơ tiếng Anh.

           Trước commit bf05d90 chuyện này KHÔNG lộ ra, vì mấy span trong khối
           giá chưa hề mang `data-i18n` — chúng vốn tiếng Anh cả đời nên không
           ai thấy gì lệch. Thêm khoá dịch vào là đẻ ra ca mới: đúng tiếng Việt
           ở lần vẽ đầu, lật sang tiếng Anh ngay cú bấm đổi quy cách đầu tiên.
           Cùng họ [[feedback_one_concept_two_sources]], chỉ khác là lệch theo
           THỜI GIAN chứ không theo vị trí.

           Đo được trên PDP nhiều quy cách, ae_lang='vi':
             mới tải       → "Giá gốc … Giá khuyến mãi … Đơn giá"
             sau cú bấm    → "Regular price … Sale price … Unit price"

           Nút mua đã được vá riêng ở toggleAddButton (vòng 24) nên nó không
           lật; đây là mảnh còn lại của cùng một con lỗi. Cùng nếp gọi với
           aef-app.js:1486 và :2092 — bọc try để bộ dịch chưa nạp cũng không
           làm vỡ luồng đổi biến thể.

           ⛔ ĐỪNG chèn gì dài dòng vào giữa hai dòng dưới. Người gác
           `test-doi-ruot-phai-dich-lai.js` đòi lời gọi bộ dịch nằm trong 12
           dòng sau lệnh chép ruột — chính vì chú thích này từng nằm ở giữa và
           đẩy nó ra ngoài tầm, làm bộ gác đỏ đúng mà trông như đỏ oan. */
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        /* Giá đã hiện lại thì câu "không tải được" cũng phải đi — hộp là anh em
           của khối giá nên lệnh chép ruột ở trên không chạm tới nó. Gỡ ở ĐÂY chứ
           không ở đầu onVariantChange: lượt mới còn đang tải thì khối giá vẫn ẩn,
           khách vẫn cần câu giải thích. Lượt cũ đã bị chốt conLaLuotMoi chặn ở
           trên nên không gỡ nhầm hộp của một lượt mới hơn vừa hỏng. */
        const hopLoi = document.getElementById('aef-variant-err');
        if (hopLoi) hopLoi.remove();
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch(() => {
        /* GIỮ arrow function: `this` ở đây là instance vì chuỗi nằm trong method.
           Đổi sang function() là mất this và bản vá thành vô hiệu trong im lặng. */
        if (!conLaLuotMoi()) return;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        /* GỠ KHOÁ THÔI LÀ CHƯA ĐỦ. Khối giá vẫn đang in giá biến thể CŨ trong khi
           URL đã trỏ biến thể MỚI — để nguyên là mời khách bấm mua với một con số
           không còn đúng. Ẩn khối giá đi và nói ra, còn hơn nói sai. */
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.add('visibility-hidden');
        this.baoLoiTaiBienThe();
      });
  }

  /* 🔴 5/9/2026 (việc S1) — "GÓI ĐANG CHỌN CÓ ĐANG BÁN DẠNG ĐẶT TRƯỚC KHÔNG?"

     KHÔNG tự tính ở đây. Câu trả lời cần ba dữ kiện (`inventory_management`,
     `inventory_policy`, `inventory_quantity`) mà bảng biến thể chuẩn của Shopify
     — thứ getVariantData() đọc — KHÔNG chở theo cái nào. Máy khách mà tự suy thì
     chỉ suy được từ `available`, và `available` chính là chỗ nhập nhằng: nó true
     cho cả "còn hàng thật" lẫn "hết hàng nhưng cho đặt trước".

     Nên máy chủ quyết một lần trong snippets/aef-dat-truoc.liquid (nguồn duy
     nhất), phát ra khoá "d" của bảng `aef-variant-meta-<section>`, và hàm này
     chỉ TRA. Dòng lời hứa dưới nút (main-product.liquid, updateVariantBits) tra
     đúng bảng ấy — hai bề mặt, một dữ kiện.

     ⚠️ Bảng chỉ được vẽ cho món NHIỀU quy cách. Món một quy cách không có bảng,
     và cũng không bao giờ có cú đổi gói nào để gọi tới đây — nhãn máy chủ vẽ
     lần đầu đứng nguyên, đúng. Trả false là đúng chứ không phải thiếu sót.
     ⚠️ Trên PDP có cả thẻ gợi ý (layout='card'). Chúng mang id biến thể khác nên
     tra bảng ra undefined ⇒ false. Không nhầm sang món khác.

     🔴 15/9/2026 (vòng 49) — NHƯNG TRÊN **THẺ** THÌ BẢNG ẤY KHÔNG TỒN TẠI.
     `aef-variant-meta-…` chỉ do sections/main-product.liquid vẽ, tức chỉ có ở
     TRANG CHI TIẾT (đo trên LIVE: /search ra 0 phần tử, PDP ra 3). Nên ở nhánh
     thẻ hàm này tra ra null và trả false cho MỌI gói — nút trên lưới không bao
     giờ nói được chữ "đặt trước", đúng nửa còn thiếu của việc S1: lời hứa chỉ
     tồn tại trên một đường đi (khách bấm thẳng từ lưới không hề đi qua PDP).

     Thẻ có bề mặt chở dữ kiện RIÊNG, nhưng vẫn do MÁY CHỦ quyết bằng ĐÚNG một
     snippet: thuộc tính `data-dat-truoc` trên từng <option> của bảng giá
     (snippets/product-card.liquid), y khuôn `data-min` / `data-mintotal` của
     vòng 40. Một câu hỏi — một công thức — hai bề mặt chở khác nhau, chứ không
     phải hai công thức. [[feedback_one_concept_two_sources]] */
  aefLaDatTruoc() {
    const v = this.currentVariant;
    if (!v) return false;
    if (this.dataset.layout == 'card') {
      const the = this.closest('.card');
      const o = the && the.querySelector(`select[data-variant-price-table] option[value="${v.id}"]`);
      return !!(o && o.dataset.datTruoc === '1');
    }
    if (this.aefBangDatTruoc === undefined) {
      this.aefBangDatTruoc = null;
      const el = document.querySelector('[id^="aef-variant-meta-"]');
      if (el) {
        try { this.aefBangDatTruoc = JSON.parse(el.textContent); } catch (e) { this.aefBangDatTruoc = null; }
      }
    }
    const m = this.aefBangDatTruoc && this.aefBangDatTruoc[v.id];
    return !!(m && m.d === 1);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    
    // Webibazaar Variant in Product Card
    var selector = `product-form-${this.dataset.section}`;
    if (this.dataset.layout == 'card') {
      selector = `product-form-${this.dataset.section}-${this.dataset.product}`;
    }
    //const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productForm = document.getElementById(selector);
    /* Đặt ngay trước chỗ dùng để người sau khỏi phải đi tìm — xem aefLaDatTruoc()
       bên dưới class này. Nó ĐỌC dữ kiện máy chủ đã quyết, không tự tính lại. */
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    /* 🔴 15/9/2026 (vòng 49) — CÁI NÚT VỪA TÌM RA KHÔNG PHẢI CÁI NÚT KHÁCH BẤM.

       Trên THẺ, `[name="add"]` là `<button class="cartb product-form__submit">`
       NẰM TRONG `<product-form>`, mà assets/aef-product-card.css khai
       `.wbproduct-container product-form, .wbproduct-container .product-form
       { display:none !important }` ngoài mọi @media ⇒ nút ấy KHÔNG BAO GIỜ hiện.
       Đã hỏi trình duyệt thật, 4 tổ hợp (🖥1440 · 📱Pixel 7) × (chủ · danh mục):
       có 14/24 cái trong DOM, NHÌN THẤY 0, chạm trúng 0 (chú thích dài ở
       snippets/product-card.liquid, khối bỏ `icon-pcart` của vòng 43).

       Nút khách thật sự bấm là `.card__quick-add` (product-card.liquid), nằm
       NGOÀI form và gửi form qua thuộc tính `form="…"`. Trước bản vá này KHÔNG
       một dòng nào trong assets/*.js ghi chữ / aria-label / disabled của nó ⇒
       khách đổi sang gói ĐÃ HẾT: giá đổi đúng, `input[name="id"]` đổi đúng, nút
       vô hình xám đi và ghi "Sold out" — còn nút khách nhìn vẫn sáng
       "+ Add to cart" và bấm được, POST /cart/add.js nhận 422.

       Vá ngay TRONG `datChu` chứ không thêm listener ở file khác: dòng `datChu`
       là NGƯỜI GHI DUY NHẤT của nhãn nút (xem chú thích nhánh gỡ khoá bên dưới).
       Thêm một người ghi nữa là dựng lại đúng Pattern 1 mà cổng cứng giỏ hàng
       cấm, và lỗi sẽ theo NHỊP sự kiện. [[feedback_one_concept_two_sources]]

       ⚠️ KHÔNG đụng `aria-disabled` của nút này: thuộc tính đó đã có chủ —
       mini-cart-popup.js (`setLoading`) bật/tắt nó trong lúc gửi. Giành ghi là
       đẻ ra đúng cái nguồn thứ hai vừa nói ở trên. `disabled` thật thì đủ: nó
       chặn cú bấm ở tầng trình duyệt (không sự kiện click, không submit) và
       trình đọc màn hình vẫn đọc ra trạng thái vô hiệu của <button>. */
    const theCha = this.dataset.layout == 'card' ? this.closest('.card') : null;
    const nutThat = theCha ? theCha.querySelector('.card__quick-add') : null;
    const chuNutThat = nutThat ? nutThat.querySelector('.card__quick-add-text') : null;

    /* 🔴 20/8/2026, vòng 24 — ĐỔI BIẾN THỂ LÀ NÚT LẬT VỀ TIẾNG ANH.

       `window.variantStrings` do layout/theme.liquid dựng từ bộ dịch của
       Shopify (`| t`), mà tiệm này KHÔNG dịch bằng cơ chế đó — chữ tiếng Việt
       đến từ từ điển riêng qua `data-i18n` (xem project_i18n_mechanism).
       Nên mọi lần đổi biến thể, dòng này ghi đè "Thêm vào giỏ" thành
       "Add to cart", và xoá luôn công sức của applyTranslations. Nút dính đáy
       📱 soi gương nút này nên nó lật theo — khách đang xem tiếng Việt bỗng
       thấy nút mua bằng tiếng Anh.

       Vá: hỏi từ điển của tiệm TRƯỚC, thiếu thì mới rơi về chuỗi của Shopify.
       Và đặt lại `data-i18n` để lần đổi ngôn ngữ sau applyTranslations còn biết
       đường vẽ lại — ghi textContent không thôi thì chữ đúng đúng MỘT lần. */
    const chuTiem = (khoa, duPhong) => {
      const t = (window.aefT && window.aefT(khoa)) || null;
      return t || duPhong;
    };
    /* 🔴 15/9/2026 (vòng 49) — KHÔNG CÓ KHOÁ THÌ KHÔNG GHI. CỔNG NẰM Ở ĐÂY.

       Bản trước có nhánh `else removeAttribute('data-i18n')`: gọi với khoá rỗng
       là chữ `chu` được ghi vào và khoá dịch bị GỠ KHỎI DOM. Từ giây đó nút
       không còn thuộc quyền applyTranslations nữa — khách bấm cờ VI thì mọi chữ
       khác đổi, riêng nút mua đứng nguyên tiếng Anh. Đúng họ lỗi `| t` mà tiệm
       này cấm tuyệt đối, và hỏng CÂM: không lỗi, không log, chỉ một cái nút
       không chịu dịch. [[project_i18n_mechanism]]

       Nhánh ấy KHÔNG phải nhánh chết: `setUnavailable()` gọi toggleAddButton với
       `variantStrings.unavailable` ("Unavailable"), chuỗi ấy khác `soldOut` nên
       rơi thẳng vào đó. Đường đi thật: PDP món có TỪ HAI trục quy cách trở lên,
       khách chọn một tổ hợp không tồn tại ⇒ `currentVariant` null ⇒
       onVariantChange gọi setUnavailable. Span `[name="add"] > span` của
       main-product.liquid mang sẵn `data-i18n` (`data-aef-btn-label`), và trên
       thẻ thì `.card__quick-add-text` cũng mang — cả hai bị gỡ khoá.

       Vá bằng CỔNG chứ không bằng cách sửa từng chỗ gọi: `datChu` là NGƯỜI GHI
       DUY NHẤT của nhãn nút, nên đặt bảo đảm "mọi chữ ra màn hình đều còn khoá
       để dịch lại" ngay tại cửa là chỗ duy nhất không ai đi vòng được. Chuỗi
       không tra ra khoá thì giữ nguyên nhãn máy chủ đã vẽ (nhãn ấy CÓ khoá,
       tức còn dịch được); nút vẫn bị khoá bằng `disabled` ở nhánh gọi, nên
       trạng thái không hề nói dối — chỉ có chữ là không đổi. */
    const datChu = (khoa, chu) => {
      if (!khoa) return;
      if (addButtonText) {
        addButtonText.textContent = chu;
        addButtonText.setAttribute('data-i18n', khoa);
      }
      if (!nutThat) return;
      if (chuNutThat) {
        chuNutThat.textContent = chu;
        chuNutThat.setAttribute('data-i18n', khoa);
      }
      /* aria-label phải đi CÙNG nhãn trong cùng lời gọi — để lệch là người dùng
         trình đọc màn hình vẫn nghe "Thêm vào giỏ" trên một gói đã hết hàng. */
      nutThat.setAttribute('aria-label', chu);
      nutThat.setAttribute('data-i18n-aria-label', khoa);
    };

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (nutThat) nutThat.setAttribute('disabled', 'disabled');
      /* `text` do bên gọi truyền vào, cũng từ variantStrings — chuỗi Shopify,
         thứ tiệm này KHÔNG dịch. Nhận ra được ca nào thì đổi sang khoá của tiệm
         cho ca đó; ca lạ thì gọi với khoá rỗng, và `datChu` từ chối ghi (xem
         cổng ở trên) chứ không in một chuỗi vĩnh viễn không dịch được.
         Giữ lời gọi ấy chứ không xoá: có nó thì cái cổng là nhánh CÒN CHẠY và
         còn được bộ gác bấm vào, xoá đi là cổng thành nhánh chưa ai thử. */
      if (text) {
        const vs = window.variantStrings || {};
        if (text === vs.soldOut) datChu('card.sold_out', chuTiem('card.sold_out', text));
        else if (text === vs.unavailable) datChu('card.unavailable', chuTiem('card.unavailable', text));
        else datChu(null, text);
      }
    } else {
      addButton.removeAttribute('disabled');
      if (nutThat) nutThat.removeAttribute('disabled');
      /* 🔴 5/9/2026 (việc S1) — NHÁNH NÀY TỪNG NÓI DỐI MỖI KHI ĐỔI GÓI.

         `disable` ở trên tính từ `!currentVariant.available`, mà `available` trả
         TRUE cho cả gói ĐÃ HẾT HÀNG đang bật `inventory_policy = continue` (Boss
         cho đặt trước). Nên đổi sang một gói như thế là nút gỡ khoá và ghi thẳng
         "Thêm vào giỏ" — khách trả tiền cho món tiệm chưa có, không một chữ báo.

         Vá ở ĐÂY chứ không thêm người ghi mới trong main-product.liquid: dòng
         `datChu` này là NGƯỜI GHI DUY NHẤT của nhãn nút. Thêm một chỗ nữa cũng
         ghi vào nó là dựng lại đúng Pattern 1 mà cổng cứng giỏ hàng cấm — và
         chỗ ghi sau sẽ đè chỗ ghi trước tuỳ thứ tự sự kiện, tức lỗi theo NHỊP,
         loại khó thấy nhất. [[feedback_one_concept_two_sources]] */
      if (this.aefLaDatTruoc()) datChu('preorder.button', chuTiem('preorder.button', 'Pre-order'));
      else datChu('card.add_to_cart', chuTiem('card.add_to_cart', (window.variantStrings || {}).addToCart));
    }

    if (!modifyClass) return;
  }

  setUnavailable() {

    // Webibazaar Variant in Product Card
    var priceSelector = `price-${this.dataset.section}`;
    if (this.dataset.layout == 'card') {
      priceSelector = `price-${this.dataset.section}-${this.dataset.product}`;
    }
    /* 🔴 15/9/2026 (vòng 49) — NHÃN "KHÔNG CÓ GÓI NÀY" CŨNG PHẢI RƠI VÀO NÚT
       KHÁCH BẤM. Hàm này trước đây tự ghi thẳng vào `[name="add"] > span`, tức
       cái nút vô hình của thẻ: trên lưới nó không đổi được một chữ nào khách
       đọc được, và nó là NGƯỜI GHI THỨ HAI của cùng một nhãn — mỗi người ghi
       một chỗ thì sớm muộn hai chỗ nói khác nhau. Đẩy nhãn qua toggleAddButton
       là trả lại một người ghi duy nhất, và nút thật được sơn theo trong cùng
       lời gọi. Khoá nút thì onVariantChange đã làm ngay trước khi gọi tới đây.
       Kèm theo: hai dòng cũ `button.querySelector(…)` gọi thẳng trên kết quả
       getElementById nên ném TypeError khi thẻ không có form — nay không còn. */
    this.toggleAddButton(true, (window.variantStrings || {}).unavailable);
    //const price = document.getElementById(`price-${this.dataset.section}`);
    const price = document.getElementById(priceSelector);
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

;

/* ===== perf-instant.js ===== */
// Phase 9 — perf polish
// (5) Debounce add-to-cart submissions: prevent rapid double-click from
//     submitting the same form twice (which would cause line-quantity x2 on
//     the same product, or race the cart-notification).
// (6) Prefetch product pages on card hover: when user hovers a product link
//     for >120ms, inject <link rel="prefetch"> so the page HTML is in the
//     browser cache by the time they click. Click feels instant.
// (9) Gộp GET /cart.js: nhiều người hỏi cùng một nhịp giỏ ⇒ MỘT lượt mạng (vòng 53,
//     code-cart#7). Chỉ trả lời thay mạng, KHÔNG ghi ô giỏ nào — xem khối (9) cuối tệp.
(function () {
  'use strict';

  /* ---------- (5) Debounce add-to-cart + INSTANT tap success flash ---------- */
  /* Optimistic UI — instant feedback before server response.
     Chỉ còn MỘT việc: mở ngăn kéo giỏ CŨ nếu ngăn đó thật sự có mặt.
     Dấu ✓ đã chuyển sang mini-cart-popup.js (17/8), còn badge/total và dòng
     hàng lạc quan đã gỡ hẳn (vòng 49) — xem ghi chú dài bên dưới. */
  let autoCloseTimer = null;
  const AUTO_CLOSE_MS = 2000;

  /* 🔴 20/8/2026, vòng 24 — HAI FILE CÙNG GHI MỘT TRẠNG THÁI, VÀ FILE NÀY GHI DỐI.

     Cặp hàm này sinh ra cho ngăn kéo giỏ CŨ kiểu Bootstrap:
         #cart-icon-bubble > .dropdown-menu
     Ngăn đó KHÔNG CÒN. Đo trên trang thật hôm nay: #cart-icon-bubble vẫn có, mà
     bên trong không còn `.dropdown-menu` nào — nút giỏ nay khai
     `aria-controls="aefMiniCart"`, tức mini-cart mới của assets/mini-cart-popup.js.

     Hậu quả: hai dòng đầu không làm gì cả (không có phần tử để bật `.show`), còn
     dòng thứ ba VẪN CHẠY — nó đặt `aria-expanded="true"` lên nút giỏ. Trình đọc
     màn hình nghe "đã mở" trong khi không có gì mở ra, và cờ đó nằm lại đó.

     Đây đúng Pattern 1 của feedback_cart_ui_anti_regression: HAI code path cùng
     ghi một phần tử giao diện giỏ. Chủ thật của `aria-expanded` trên #toggleCountCart
     là mini-cart-popup.js (nó mở/đóng #aefMiniCart và tự đặt cả `aria-controls`).
     File này chỉ được ghi khi ngăn CŨ thật sự có mặt.

     KHÔNG xoá hẳn cặp hàm: nếu ở đâu đó còn dựng ngăn cũ thì nó vẫn phải chạy.
     Chốt bằng SỰ TỒN TẠI của `.dropdown-menu`, không bằng cờ hay bằng phỏng đoán. */
  function nganCu() {
    const dropdown = document.getElementById('cart-icon-bubble');
    const drawer = dropdown && dropdown.querySelector('.dropdown-menu');
    return drawer ? { dropdown: dropdown, drawer: drawer } : null;
  }
  function closeCartDrawer() {
    const n = nganCu();
    if (!n) return;   // ngăn cũ không còn ⇒ không ghi gì hết, kể cả aria-expanded
    n.dropdown.classList.remove('show');
    n.drawer.classList.remove('show');
    const toggle = document.getElementById('toggleCountCart');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
  function scheduleAutoClose() {
    if (autoCloseTimer) clearTimeout(autoCloseTimer);
    autoCloseTimer = setTimeout(closeCartDrawer, AUTO_CLOSE_MS);
  }
  function cancelAutoClose() {
    if (autoCloseTimer) { clearTimeout(autoCloseTimer); autoCloseTimer = null; }
  }
  function openCartDrawer() {
    const n = nganCu();
    if (!n) return;   // xem ghi chú ở closeCartDrawer
    n.dropdown.classList.add('show');
    n.drawer.classList.add('show');
    const toggle = document.getElementById('toggleCountCart');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    scheduleAutoClose();
  }

  /* Drawer hover/touch interaction → cancel/reschedule auto-close */
  document.addEventListener('mouseover', function (e) {
    const inDrawer = e.target.closest && e.target.closest('#cart-icon-bubble .dropdown-menu');
    if (inDrawer) cancelAutoClose();
  });
  document.addEventListener('mouseout', function (e) {
    const inDrawer = e.target.closest && e.target.closest('#cart-icon-bubble .dropdown-menu');
    const toRelated = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('#cart-icon-bubble .dropdown-menu');
    /* Only reschedule when leaving the drawer entirely (not moving between children) */
    if (inDrawer && !toRelated) scheduleAutoClose();
  });
  /* Mobile: any tap inside drawer = user is interacting → reset timer */
  document.addEventListener('touchstart', function (e) {
    const inDrawer = e.target.closest && e.target.closest('#cart-icon-bubble .dropdown-menu');
    if (inDrawer) {
      cancelAutoClose();
      /* Reschedule from the moment of touch — gives 3s after they stop tapping */
      setTimeout(scheduleAutoClose, 0);
    }
  }, { passive: true });
  /* 🔴 15/9/2026, vòng 49 — GỠ "MÓN HÀNG LẠC QUAN": HAI FILE CÙNG GHI MỘT NODE.

     Ở đây từng có `getCardPriceCents()`, một listener `cart:updated` dọn
     `.ae-optimistic-item`, và `insertOptimisticItem()` chèn một dòng hàng GIẢ
     vào `#cart-icon-bubble #webi-main-cart-items .js-contents` ngay lúc bấm "+".

     Cả cụm sinh ra cho ngăn kéo giỏ Bootstrap cũ (sections/cart-icon-bubble.liquid),
     mà section đó nay KHÔNG CÒN ĐƯỢC RENDER ở đâu — không templates/*.json,
     không sections/*-group.json, không lời render nào gọi tới.
     Cái `#cart-icon-bubble` còn sống hôm nay là `div.aef-cart-wrap` ở
     sections/header.liquid, và nó BỌC mini-cart popup — popup có đúng
     `#webi-main-cart-items > .js-contents` (snippets/mini-cart-popup.liquid).
     Nghĩa là bộ chọn kia KHÔNG trượt đi đâu cả: nó trỏ thẳng vào chính cái node
     mà `renderRows()` của mini-cart-popup.js ghi đè bằng
     `listContainer.innerHTML = html`. Hai code path ghi MỘT DOM target — đúng
     Pattern 1 mà feedback_cart_ui_anti_regression cấm.

     Tệ hơn: mọi phép SO KHỚP của cụm này dùng lớp `.wbheadcartdrop`, trong khi
     mini-cart in dòng hàng bằng `.aef-mini-cart__row`. Nhánh "món này đã có
     trong giỏ ⇒ cộng dồn" vì thế KHÔNG BAO GIỜ khớp — nó luôn chèn thêm một
     dòng TRÙNG; và cái hẹn giờ 6 giây tự gỡ node sẽ ăn vào danh sách do
     mini-cart vẽ.

     VÌ SAO GỠ CHỨ KHÔNG SỬA: nhánh này CHƯA TỪNG chạy trước mắt khách —
     assets/aef-cart-drawer.css đặt `.aef-mini-cart { display: none !important }`
     nên popup ẩn vĩnh viễn. Nhánh chưa chạy thì câu hỏi đúng là "GỠ hay SỬA",
     không phải "sửa thế nào". Muốn giữ phản hồi tức thì thì phải dựng lại bằng
     `.aef-mini-cart__row` + khớp `data-product-id` như renderItems — tức là cố
     tình nuôi người ghi THỨ HAI cho cùng một node, đúng thứ Pattern 1 cấm. Vậy
     chốt: mini-cart-popup.js là NGƯỜI GHI DUY NHẤT của `.js-contents`.

     `window.AE_LAST_ADDED_HANDLE` đi theo luôn: cả kho chỉ có file này tự ghi
     (trong handler click) và tự đọc (trong listener vừa gỡ), không ai khác dùng.

     Người gác: scripts/test-perf-instant-khong-ghi-ruot-mini-cart.js */

  document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('.card__quick-add');
    if (!btn) return;
    /* 2026-08-17 — BỎ dấu ✓ dán ngay lúc bấm.
     *
     * Hai dòng cũ ở đây là:
     *     btn.classList.add('is-added');
     *     setTimeout(function () { btn.classList.remove('is-added'); }, 900);
     * tức khẳng định "đã thêm xong" ở mốc 0ms, rồi rút lại ở mốc 900ms — trong
     * khi /cart/add.js trên 3G mất 400–1500ms và có thể trả 422. Ba hệ quả đo
     * được, không phải suy đoán:
     *   · máy chủ TỪ CHỐI thì dấu ✓ vẫn diễn xong. Đây chính là "ba lời hứa giả"
     *     mà test-card-add-error-toast.js sinh ra để canh; toast đỏ vá được phần
     *     CHỮ nhưng dấu ✓ xanh vẫn nói ngược lại cùng lúc.
     *   · thành công CHẬM hơn 900ms thì khách thấy ✓ tắt trước khi giỏ nhảy số
     *     ⇒ tưởng hụt ⇒ bấm lại (nay đã có chốt chặn ở mini-cart-popup.js, nhưng
     *     chốt là cái lưới, không phải cách chữa).
     *   · `.is-added` mang `!important` nên nó ĐÈ luôn trạng thái đang-gửi vừa
     *     dựng — nút hiện nền xanh "xong rồi" trong khi vòng quay đang chạy.
     *
     * Nay ai thật sự BIẾT kết quả thì người đó vẽ: mini-cart-popup.js gắn
     * `.is-added` trong nhánh thành công của hàng đợi. Đúng Pattern 1 — một
     * DOM target, một người ghi. File này nay chỉ còn giữ đúng một việc: mở
     * ngăn kéo CŨ nếu ngăn đó có mặt (vòng 49 đã gỡ dòng hàng lạc quan). */
    /* BUG-C (2026-05-29): badge + total are now both written from
       mini-cart-popup.queueAdd's success handler in the same syncCountAndState
       call once /cart/add.js confirms the add. Earlier, perf-instant wrote
       CartTotalText optimistically and dispatched cart:updated{total} on
       click, which triggered mini-cart-popup's listener to refreshFromServer
       → fetch /cart.js → see the empty pre-add cart → write CartTotalText
       back to $0.00. The total oscillated $0 ↔ $2.99 six times in 750ms on
       a single click. Dropping both the textContent write and the dispatch
       removes the premature path; only the drawer open is kept (the optimistic
       placeholder line was removed in vòng 49 — see the long note above), and
       free-shipping-bar's own fetch interception refreshes it ~80ms after the
       /cart/add.js response. */
    /* KHÔNG ghi một chữ nào vào ruột mini-cart ở đây. */
    setTimeout(openCartDrawer, 250);
  }, true);

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    if (form.dataset.aeSubmitting === '1') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    form.dataset.aeSubmitting = '1';
    /* DO NOT disable the button — that breaks the optimistic ✓ animation.
       Debounce by submitting flag only. */
    /* 21/9/2026 — VÁ 2 KÝ TỰ HỎNG U+FFFD ở đúng dòng trên.
       ĐO ĐƯỢC: chỗ dấu gạch mang 6 byte EF BF BD EF BF BD, tức HAI ký tự
       U+FFFD đã được ghi thẳng vào file, không phải byte rác còn sót.
       Có sẵn từ commit b881303 (16/7/2026, cú "pull full theme" đầu tiên)
       ⇒ hỏng từ bản theme trên Shopify, KHÔNG có bản sạch nào trong git
       để lấy lại. Không phải hồi quy của vòng này.
       VÌ SAO CHỌN em dash — và ĐỪNG lấy con số 2 làm luật chung:
       "—" (U+2014) mã hoá UTF-8 là E2 80 94; mất byte dẫn E2 thì còn 80 94,
       bộ giải mã trả về đúng HAI U+FFFD. NHƯNG đo lại 21/9 thì con số 2
       KHÔNG chỉ đích danh em dash: MỌI ký tự 3 byte mất byte dẫn đều cho 2
       — en dash (80 93) → 2 · ba chấm (80 A6) → 2 · mũi tên (86 92) → 2 ·
       nháy cong (80 99) → 2. Con số 2 chỉ nói được "một ký tự 3 byte đã mất
       byte dẫn", hết. (Các kiểu mất byte KHÁC thì đúng là ra 1 nên loại
       được thật: E2 80 → 1, E2 94 → 1, 0x97 kiểu cp1252 → 1.)
       CÁI THẬT SỰ PHÂN ĐỊNH là kiểm kê ký tự của chính bản gốc b881303:
       em dash 13 lần · en dash 0 · ba chấm 0 · nháy cong 0 · mũi tên 7.
       Ba ứng viên kia có mặt 0 lần nên tự loại — chỉ còn em dash và mũi tên,
       và hai cái đó tách nhau bằng VĂN PHONG: 13 em dash đều theo khuôn "cụm
       danh từ — mệnh đề giải thích" ("from the moment of touch — gives 3s",
       "(hidden) arrow buttons — JS click() works", "too aggressive — caused
       3-4s lag"); còn 7 mũi tên CHỈ nối hành-động-sang-hành-động (dòng 212
       bản gốc: "→ fetch /cart.js → see the empty pre-add cart → write
       CartTotalText") và không lần nào đứng trước "that". Câu đang vá là
       mệnh đề giải thích ⇒ em dash.
       BẪY CHO NGƯỜI SAU: bản gộp assets/aef-head.js cũng mang 6 byte hỏng
       này (cùng một dòng chữ). ĐỪNG sửa tay vào bản gộp — chạy
       scripts/build-js-bundles.js để nó lấy lại từ nguồn, nếu không
       scripts/test-ban-gop-khop-nguon.js sẽ đỏ, và lần build kế tiếp sẽ
       xoá mất bản vá tay đó. */
    const reset = function () { form.dataset.aeSubmitting = ''; };
    setTimeout(reset, 1500);
    document.addEventListener('cart:updated', reset, { once: true });
  }, true);

  /* ---------- (7) Carousel swipe-hint animation ----------
     On first viewport entry, briefly slides the carousel right then back so
     customers discover horizontal swipe (replaces hidden prev/next arrows). */
  function hintCarousel(carousel) {
    /* Skip slideshow (.owl-slider for hero banner) — only product carousels */
    if (carousel.classList.contains('owl-slider')) return;

    /* Method 1: jQuery slick API */
    if (window.jQuery) {
      const $ = window.jQuery;
      const $c = $(carousel);
      if ($c.hasClass('slick-initialized')) {
        $c.slick('slickNext');
        setTimeout(function () { $c.slick('slickPrev'); }, 700);
        return;
      }
      if ($c.hasClass('owl-loaded')) {
        $c.trigger('next.owl.carousel', [500]);
        setTimeout(function () { $c.trigger('prev.owl.carousel', [500]); }, 700);
        return;
      }
    }
    /* Method 2: click the (hidden) arrow buttons — JS click() works on display:none */
    const next = carousel.querySelector('.slick-next, .owl-next');
    const prev = carousel.querySelector('.slick-prev, .owl-prev');
    if (next) {
      next.click();
      setTimeout(function () { if (prev) prev.click(); }, 700);
    }
  }

  function bindCarouselHints() {
    if (!('IntersectionObserver' in window)) return;
    const carousels = document.querySelectorAll('.slick-slider, .owl-carousel, .wbproduct-slider');
    if (!carousels.length) return;
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.swipeHinted) {
          entry.target.dataset.swipeHinted = '1';
          /* Slight delay so carousel finishes init + page settles */
          setTimeout(function () { hintCarousel(entry.target); }, 350);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.45 });
    carousels.forEach(function (c) { observer.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      /* Wait additional 600ms for Slick/Owl to fully init across all sections */
      setTimeout(bindCarouselHints, 600);
    });
  } else {
    setTimeout(bindCarouselHints, 600);
  }

  /* ---------- (6) Prefetch on hover — covers products, collections, blogs, pages ----------
     When the user hovers a link for ~65ms (or touches it), we inject <link rel="prefetch">
     so the page HTML is in the browser cache by the time they click. Click feels instant. */
  const prefetched = new Set();
  /* 🔴 vòng 48, 14/9/2026 — HAI CHỐT RẺ trước khi kéo bất cứ trang nào về.
     Đo trang thật hôm nay: /products/acecook-thailand-hotpot-noodles-2-9oz =
     529.717 byte thô · 157.350 byte gzip · 128.807 byte brotli. Trước bản vá này
     KHÔNG có trần nào: một trang danh mục có 24 thẻ, mỗi thẻ mang `?variant=` riêng
     nên `Set prefetched` (khoá theo URL) không chặn được cái nào ⇒ trần xấu nhất là
     24 × ~126 KB ≈ 3 MB dữ liệu di động cho MỘT lượt xem.
     (1) Save-Data / 2g: khách đã tự nói "đừng tốn data của tôi" thì im lặng.
     (2) MAX_PREFETCH: nhiều nhất 8 trang mỗi lượt xem — đủ cho hành vi thật
         (khách bấm vào 1-2 thẻ), cắt hẳn cái đuôi 24 thẻ.
     Chốt saveData chép đúng khuôn hàng xóm assets/tiny-img-link-preloader.js
     (instant.page) đang chạy cùng site — đừng chế luật thứ ba. */
  const MAX_PREFETCH = 8;
  function prefetchAllowed(url) {
    if (!url) return false;
    if (prefetched.has(url)) return false;
    if (prefetched.size >= MAX_PREFETCH) return false;
    const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return false;
    return true;
  }
  function prefetch(url) {
    if (!prefetchAllowed(url)) return;
    prefetched.add(url);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }
  /* Match any internal navigation worth pre-loading. Excludes cart/checkout/account
     (sensitive, dynamic) and external URLs. */
  const PREFETCH_PATTERN = /\/(products|collections|blogs|pages)\/[a-z0-9\-_%]/i;
  function isPrefetchable(href) {
    if (!href) return false;
    if (href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return false;
    return PREFETCH_PATTERN.test(href);
  }
  let hoverTimer = null;
  let hoverLink = null;
  function onEnter(e) {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (!isPrefetchable(href)) return;
    if (a.href === hoverLink) return;
    hoverLink = a.href;
    clearTimeout(hoverTimer);
    /* 65ms — short enough that even quick clicks trigger preload, long enough
       to skip accidental hovers during scroll. */
    hoverTimer = setTimeout(function () { prefetch(hoverLink); }, 65);
  }
  function onLeave() {
    clearTimeout(hoverTimer);
    hoverLink = null;
  }
  document.addEventListener('mouseover', onEnter, { passive: true });
  document.addEventListener('mouseout', onLeave, { passive: true });
  /* 🔴 vòng 48, 14/9/2026 — ĐẶT NGÓN XUỐNG CHƯA PHẢI LÀ BẤM.
     Bản cũ ở đây gọi thẳng `prefetch(a.href)` ngay trong `touchstart`: không trễ,
     không huỷ được, không biết ngón đang BẤM hay đang VUỐT. Trên lưới sản phẩm gần
     trọn diện tích ô là <a href="/products/…"> (đo /collections/snacks: 24/24 thẻ),
     nên mỗi cú đặt ngón để CUỘN kéo về nguyên trang chi tiết ~126 KB (brotli).
     Dựng lại bằng jsdom: 10 cú vuốt (touchstart→touchmove→touchend, không hề bấm)
     ⇒ 10 thẻ <link rel=prefetch> ≈ 1,26 MB cho những trang khách không mở.
     Nhánh hover ngay trên đã có 65ms chờ + `onLeave` huỷ; nhánh chạm thì không có gì.

     KHÔNG gỡ prefetch — cú prefetch đúng lúc mới là thứ làm trang mở tức thì.
     Chỉ đổi TÍN HIỆU:
       · touchstart  → chỉ GHI NHỚ link + toạ độ rồi hẹn giờ TOUCH_ARM_MS, chưa kéo gì;
       · touchmove   → ngón nhích quá TOUCH_MOVE_TOLERANCE px = đang cuộn ⇒ huỷ;
       · touchcancel → huỷ;
       · touchend    → ngón nhấc mà chưa nhích = BẤM THẬT ⇒ kéo NGAY, kể cả cú chạm
                       nhanh hơn 65ms, nên không mất ưu thế so với sự kiện `click`
                       (click còn phải chờ touchend rồi mới bắn).
     Giữ đúng khuôn của hàng xóm tiny-img-link-preloader.js: vuốt là huỷ. */
  const TOUCH_ARM_MS = 65;
  const TOUCH_MOVE_TOLERANCE = 10; /* px */
  let touchTimer = null;
  let touchUrl = '';
  let touchX = 0;
  let touchY = 0;
  /* MỘT thẻ <link> dùng lại cho cả đời trang (bản cũ tạo thẻ MỚI mỗi URL và không
     bao giờ gỡ ⇒ cuộn hết một danh mục là 24 thẻ đọng lại trong <head>).
     Dùng lại còn cho phép HUỶ: gỡ `href` là trình duyệt bỏ request đang bay —
     cần cho cú "đặt ngón, ngập ngừng hơn 65ms rồi mới vuốt". */
  let touchLink = null;
  let touchUncommitted = false; /* đang bay nhưng chưa chắc là cú bấm ⇒ được phép huỷ */
  function touchSend(url) {
    if (!touchLink) {
      touchLink = document.createElement('link');
      touchLink.rel = 'prefetch';
      touchLink.as = 'document';
      document.head.appendChild(touchLink);
    }
    touchLink.href = url;
  }
  function touchCancel() {
    clearTimeout(touchTimer);
    touchTimer = null;
    touchUrl = '';
    /* đang bay dở mà khách vuốt ⇒ gỡ href, huỷ luôn request.
       Chỉ huỷ cái CHƯA CHỐT — cú bấm thật đã chốt thì để yên cho nó về. */
    if (touchUncommitted && touchLink) touchLink.removeAttribute('href');
    touchUncommitted = false;
  }
  /* Hết 65ms mà ngón chưa nhích: bắt đầu kéo, nhưng CHƯA ghi vào `prefetched` —
     chưa chắc là cú bấm, còn huỷ được. */
  function touchArmed() {
    touchTimer = null;
    if (!touchUrl) return;
    touchSend(touchUrl);
    touchUncommitted = true;
  }
  /* Ngón nhấc mà chưa nhích = BẤM THẬT: kéo ngay (nếu chưa kéo) và chốt vào
     `prefetched` để nhánh hover/mouseover sau đó không kéo lại lần nữa. */
  function touchFire() {
    if (!touchUrl) return;
    clearTimeout(touchTimer);
    touchTimer = null;
    const url = touchUrl;
    touchUrl = '';
    /* chưa kịp bay (cú chạm nhanh hơn 65ms) thì kéo ngay bây giờ */
    if (!touchUncommitted) {
      if (!prefetchAllowed(url)) return;
      touchSend(url);
    }
    prefetched.add(url);
    touchUncommitted = false;
  }
  document.addEventListener('touchstart', function (e) {
    touchCancel();
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (!isPrefetchable(href)) return;
    if (!prefetchAllowed(a.href)) return;
    const t = e.touches && e.touches[0];
    touchX = t ? t.clientX : 0;
    touchY = t ? t.clientY : 0;
    touchUrl = a.href;
    touchTimer = setTimeout(touchArmed, TOUCH_ARM_MS);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!touchUrl) return;
    const t = e.touches && e.touches[0];
    if (!t) return;
    if (Math.abs(t.clientX - touchX) > TOUCH_MOVE_TOLERANCE ||
        Math.abs(t.clientY - touchY) > TOUCH_MOVE_TOLERANCE) touchCancel();
  }, { passive: true });
  document.addEventListener('touchcancel', touchCancel, { passive: true });
  document.addEventListener('touchend', touchFire, { passive: true });

  /* ---------- (8) Speculation Rules API — modern Chromium browsers prerender
     (full load + JS execute) on intent signals. Truly instant navigation when supported. */
  if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    const rules = document.createElement('script');
    rules.type = 'speculationrules';
    /* Conservative: prerender only on click intent (not hover). Scope limited to product/collection/blog paths.
       Earlier "moderate + /*" was too aggressive — caused 3-4s post-load lag from prerendering many pages
       in parallel. Conservative trades a tiny bit of nav speed for much smoother initial page load. */
    rules.textContent = JSON.stringify({
      prerender: [{
        where: {
          or: [
            { href_matches: '/products/*' },
            { href_matches: '/collections/*' },
            { href_matches: '/blogs/*' }
          ]
        },
        eagerness: 'conservative'
      }]
    });
    document.head.appendChild(rules);
  }

  /* ---------- (9) MỘT lượt GET /cart.js cho mọi người hỏi cùng lúc ----------
     🔴 26/9/2026, vòng 53 (code-cart#7) — BỐN NGƯỜI HỎI MỘT CÂU, BỐN LƯỢT MẠNG.

     Sau MỖI lượt ghi giỏ, bốn tệp tự đi hỏi /cart.js, không tệp nào biết tệp nào:
       · aef-fsb.js             bộ bọc fetch ⇒ 80ms sau ⇒ refresh()
       · cart-card-indicator.js bộ bọc fetch ⇒ 200ms sau ⇒ syncFromCart()
       · mini-cart-popup.js     nghe cart:updated ⇒ refreshFromServer()
       · card-stepper.js        nghe cart:updated ⇒ 120ms sau ⇒ scheduleReconcile()
     ĐO TRÊN LIVE (jsdom chạy nguyên văn tệp LIVE, máy chủ giả có trạng thái): một cú
     "+ Add" = 1 POST + 4 GET /cart.js giống hệt nhau; một cú "+" ô tăng/giảm = 1 POST
     + 4 GET; tải trang = 3–4 GET. /cart.js không mang header cache nào nên trình
     duyệt không gộp giúp — cả bốn ra mạng thật (~3,5 KB/lượt cho giỏ 1 dòng).

     GỘP Ở ĐÂY, TẦNG MẠNG — KHÔNG sửa bốn người hỏi. aef-head.js chạy TRƯỚC
     mini-cart-popup.js và aef-app.js, nên bộ bọc này nằm TRONG CÙNG xích fetch và
     thấy mọi lượt đọc lẫn mọi lượt ghi. Bốn người vẫn giữ nguyên logic của mình và
     vẫn đọc SỐ THẬT của máy chủ; chỉ là cùng một câu trả lời.

     KHÔNG đi đường "đính giỏ vào detail của cart:updated rồi cho người nghe ăn":
       · thân /cart/change.js dính BUG-H (total_price phồng giả 200–400ms, chú thích
         ở card-stepper.js commitChange) — mini-cart CỐ Ý dùng total_price cho
         #CartTotalText (mini-cart-popup.js refreshFromServer), ăn thân đó là hiện số ma;
       · /cart/add.js chỉ trả DÒNG hàng ⇒ muốn đính giỏ phải chờ thêm một vòng mạng
         mới phát được sự kiện ⇒ chậm đường nhanh BUG-F (thẻ đổi thành ô tăng/giảm).

     LUẬT DÙNG CHUNG — "nhịp" tăng mỗi khi giỏ CÓ THỂ vừa đổi:
       · một lượt ghi giỏ BẮT ĐẦU và khi nó XONG (kể cả hỏng);
       · một sự kiện cart:updated / cart:item-added / product:added-to-cart /
         cart:added (bắt ở pha capture của window ⇒ chạy trước mọi người nghe).
     Người hỏi sau chỉ nhận chung một lượt GET khi lượt đó BẮT ĐẦU CÙNG NHỊP — tức
     không có lượt ghi nào chen giữa lúc nó đi và lúc người sau hỏi. Nên lời hứa
     "lượt syncFromCart CUỐI chốt số thật" (BUG-Z) vẫn giữ: GET khởi đầu trước lượt
     ghi cuối không bao giờ được trả cho người hỏi sau lượt ghi đó.
     Lượt GET đã về còn được dùng lại thêm CUA_SO_TUOI_MS: bốn người hỏi trải trong
     ~200ms sau lượt ghi, còn mạng nhanh (📱 wifi/🖥 cáp) trả lời trước khi người
     cuối kịp hỏi — chỉ gộp lượt đang bay thì ở mạng nhanh vẫn ra 2–3 lượt.

     Mỗi người nhận một BẢN SAO (Response.clone) — thân Response chỉ đọc được một lần.
     Không gộp: Request object, có signal (hẹn giờ huỷ của ngăn giỏ), credentials
     'omit' (giỏ khác), có query. Lượt ghi đi bằng XHR không qua đây: trong theme
     không còn ai ghi giỏ bằng XHR (wbcartdropdown.js đã gỡ 15/9), và cửa sổ dùng lại
     chỉ 300ms (ngoài pha dựng trang — xem PHA_DUNG_MS).

     Tệp này KHÔNG ghi một ô giỏ nào (Pattern 1) — chỉ trả lời thay mạng.
     Đếm trên trang thật: window.aefThongKeDocGio = { mang, chung, phaDung, coPhaDung }
     (phaDung = số lượt dùng chung mà CHỈ luật pha dựng trang cho phép).
     Người gác: scripts/test-mot-cu-bam-mot-luot-hoi-gio.js */
  (function gopDocGio() {
    if (window.__aefGopDocGio || typeof window.fetch !== 'function') return;
    window.__aefGopDocGio = true;

    const goc = window.fetch;
    const CUA_SO_TUOI_MS = 300;
    const GHI_GIO = /\/cart\/(add|change|update|clear)(\.js)?$/;
    /* Ajax Cart API: mọi lượt KHÔNG-GET vào /cart hoặc /cart/… (form giỏ, add/change/
       update/clear có hay không đuôi .js, và những cửa /cart/… khác) — kể cả tiền tố
       ngôn ngữ /vi/cart/…. Storefront API: /api/<phiên bản>/graphql(.json). */
    const DUONG_GIO = /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart(\/|$)/i;
    const GRAPHQL = /^(\/[a-z]{2}(-[a-z]{2})?)?\/api\/[^/]+\/graphql(\.json)?$/i;
    const DOC_GIO = /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\.js$/i;
    let nhip = 0;
    let chung = null; /* { nhip, p, xong, phaDung } — lượt GET đang được dùng chung */

    /* 🔴 27/9/2026 (vòng 53, phu3) — PHA DỰNG TRANG: MỐC LÀ DOMContentLoaded, KHÔNG PHẢI SỐ ms.
       Đo LIVE (/collections/all, giỏ trống, 📱+🖥, chỉ aef-head.js của nhánh tiêm bằng
       page.route): lượt đọc đầu (detectFromCart, lúc aef-head.js chạy) đi ~410–580 ms;
       card-stepper hỏi lúc DOMContentLoaded + 120 ms (~1.100–1.320 ms) vì aef-app.js nạp
       defer, phải chờ tải xong. Tới lúc đó ảnh chụp đầu đã quá CUA_SO_TUOI_MS ⇒ lượt GET
       thứ hai ra mạng (3/4 lượt đo), dù giữa hai lượt KHÔNG có lượt ghi hay sự kiện giỏ nào.
       Máy yếu thì DOMContentLoaded còn tới muộn hơn ⇒ nới cửa sổ bằng một số ms cố định
       không đủ, phải neo vào chính DOMContentLoaded.
       Luật: ảnh chụp mở khi trang CHƯA có lượt ghi / sự kiện giỏ nào (nhịp 0) và đang trong
       pha dựng (từ lúc tệp này chạy tới DOMContentLoaded + PHA_DUNG_MS) được dùng lại cho
       mọi người hỏi trong pha đó. Lượt ghi / cart:updated vẫn xé như cũ (tangNhip xoá
       `chung`, nhịp thôi là 0). Qua pha ⇒ chỉ còn CUA_SO_TUOI_MS.
       Không biết chắc DOMContentLoaded đã qua chưa (tệp nạp sau lúc đó, trình duyệt thiếu
       Navigation Timing) ⇒ KHÔNG có pha dựng: đúng cách cũ, tốn thêm lượt mạng chứ không
       trả số cũ.
       Cái giá, nói thẳng: lượt ghi mà trang KHÔNG thấy (tab khác, app ghi bằng XHR) xảy ra
       đúng lúc trang đang dựng thì mọi người hỏi của pha dựng cùng nhận số cũ, tới lượt ghi
       hay cart:updated kế tiếp — như chữ Liquid in sẵn trong HTML.
       Người gác: scripts/test-mot-cu-bam-mot-luot-hoi-gio.js (tải trang + ⑦ với độ trễ
       DOMContentLoaded thật · ⑦b pha dựng phải HẾT · ⑦c cart:updated trong pha dựng). */
    const PHA_DUNG_MS = 1000;
    let mocDung = 0; /* Date.now() lúc DOMContentLoaded; 0 = chưa tới */
    const coPhaDung = (function () {
      const s = document.readyState;
      if (s === 'loading') return true;
      if (s !== 'interactive') return false;
      /* 'interactive' là cả lúc chạy script defer (TRƯỚC DOMContentLoaded — aef-head.js nạp
         kiểu này) lẫn sau DOMContentLoaded tới lúc load ⇒ hỏi Navigation Timing. */
      try {
        const n = typeof performance.getEntriesByType === 'function' ? performance.getEntriesByType('navigation')[0] : null;
        if (n) return n.domContentLoadedEventStart === 0;
        const t = performance.timing;
        return !!t && t.domContentLoadedEventStart === 0;
      } catch (e) { return false; }
    })();
    if (coPhaDung) document.addEventListener('DOMContentLoaded', function () { mocDung = Date.now(); });
    function trongPhaDung() {
      if (!coPhaDung) return false;
      if (!mocDung) return document.readyState !== 'complete';
      return Date.now() - mocDung <= PHA_DUNG_MS;
    }

    const thongKe = { mang: 0, chung: 0, phaDung: 0, coPhaDung: coPhaDung };
    window.aefThongKeDocGio = thongKe;

    function tangNhip() { nhip++; chung = null; }
    /* Số lượt ghi giỏ đang bay, kể cả lượt của /cart (không đi qua __aefCartAddPending).
       assets/aef-qua-tang.js hỏi con số này để không ghi dòng quà chen vào lượt của khách. */
    let dangGhi = 0;
    window.aefDangGhiGio = function () { return dangGhi; };

    /* 🎁 31/10/2026 (thanh báo quà tặng) — NGHE ẢNH GIỎ, CA THƯỜNG KHÔNG THÊM LƯỢT HỎI NÀO.
       Mọi lượt đọc /cart.js dùng chung được đều đi qua lớp này (lượt mang signal thì không,
       xem laDocGio), nên người cần "giỏ vừa đổi" nghe ở đây thay vì tự đi hỏi:
       aefNgheGio(fn) ⇒ fn(cart) cho mỗi lượt GET ra mạng thật.
       Người nghe đăng ký lúc lượt đang bay nhận ảnh cùng lượt đó; đăng ký sau khi lượt đã về
       (aef-app.js defer) thì nhận luôn ảnh đang dùng chung. Không ai nhận trùng một ảnh.
       Ảnh của lượt bị lượt ghi chen (nhịp đã đổi) bị bỏ: nó có thể cũ. Lượt ghi thành công
       luôn có GET theo sau (aef-fsb.js, cart-card-indicator.js). Lượt ghi HỎNG MẠNG thì không
       ai hỏi lại, thanh kẹt ảnh cũ: có người nghe thì lớp này hẹn đúng một GET, qua
       window.fetch nên dùng chung được với lượt đang bay. Lượt ghi trả về mã lỗi không đi
       nhánh này: bên gọi tự xử lý. Tệp này vẫn không ghi một ô giỏ nào.
       Không ai nghe ⇒ không clone, không parse, không hẹn.
       Người gác: scripts/test-qua-tang-logic.js */
    const DOC_LAI_SAU_MS = 300;
    const nguoiNghe = [];
    let henDocLai = 0;
    function docLaiSauGhiHong() {
      if (!nguoiNghe.length || henDocLai) return;
      henDocLai = setTimeout(function () {
        henDocLai = 0;
        window.fetch('/cart.js', { credentials: 'same-origin' }).catch(function () {});
      }, DOC_LAI_SAU_MS);
    }
    function phatAnh(r, nhipDi, fns) {
      if (!r || !r.ok || typeof r.clone !== 'function') return;
      let than;
      /* Thân đã bị đọc bởi lớp bọc lạ thì clone ném: đừng để lỗi này cắt sổ sách của lượt đọc chung. */
      try { than = r.clone().json(); } catch (e) { return; }
      than.then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number' || nhipDi !== nhip) return;
        fns.forEach(function (fn) { try { fn(cart); } catch (e) {} });
      }, function () {});
    }
    window.aefNgheGio = function (fn) {
      if (typeof fn !== 'function') return;
      nguoiNghe.push(fn);
      if (chung && chung.xong) { const muc = chung; muc.p.then(function (r) { phatAnh(r, muc.nhip, [fn]); }, function () {}); }
    };

    /* null = không đọc được địa chỉ · { khac: true } = khác nguồn */
    function diaChi(input) {
      const s = typeof input === 'string' ? input
        : (input && typeof input.url === 'string') ? input.url
        : (input && typeof input.href === 'string') ? input.href : '';
      if (!s) return null;
      try {
        const u = new URL(s, location.href);
        if (u.origin !== location.origin) return { khac: true };
        return { duong: u.pathname, hoi: u.search };
      } catch (e) { return null; }
    }
    function phuongThuc(input, init) {
      return String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
    }
    /* "Lượt này CÓ THỂ đổi giỏ không" — nhịp tăng thừa chỉ tốn thêm một lượt mạng, nhịp
       thiếu là trả số cũ.
       🔴 27/9/2026 (vòng 53, phu3) — DANH SÁCH ĐƯỜNG GIỎ, KHÔNG PHẢI "MỌI POST".
       Bản trước coi MỌI lượt không-GET cùng nguồn (trừ /.well-known/) là "có thể đổi".
       Đo trên trang LIVE (aef-head.js phục vụ kèm móc nhật ký, 📱): số liệu của Shopify
       đi bằng chính window.fetch nên xuyên qua lớp gộp —
         · tải collection: detectFromCart hỏi /cart.js (nhịp 0) → 22 ms sau perf-kit gửi
           POST /api/collect ⇒ nhịp 1 ⇒ mini-cart-popup hỏi riêng; POST đó xong ⇒ nhịp 2
           ⇒ thêm một lượt nữa. 3 GET /cart.js, lẽ ra 1.
         · "+" ô tăng/giảm và "+" trong ngăn giỏ: shop_events_listener gửi
           POST /api/unstable/graphql.json?operation_name=limitedCartQuery (một câu HỎI
           giỏ, không ghi gì) chen giữa những người hỏi ⇒ 3 GET/thao tác, lẽ ra 1.
       Nay chỉ các cửa GHI giỏ của Shopify mới tăng nhịp — suy từ chính nguồn theme (mọi
       lượt ghi giỏ trong assets/ sections/ đều đi /cart/add|change|update(.js) hoặc
       routes.cart_*_url) và từ hai API ghi giỏ công khai của Shopify:
         · Ajax Cart API — mọi lượt không-GET vào /cart hoặc /cart/… (DUONG_GIO), cùng
           GHI_GIO cho cả GET (giữ như cũ);
         · Storefront API — POST graphql, TRỪ khi thân là một câu query (GraphQL: query
           không đổi được dữ liệu). Thân không đọc được (Request, FormData, persisted
           query…) ⇒ vẫn coi là "có thể đổi".
       Lượt ghi đi bằng XHR vẫn không qua đây (như cũ); cart:updated vẫn tăng nhịp.
       Lượt credentials:'omit' đứng TRƯỚC mọi luật trên (vòng 53, L1): giỏ phụ Storefront
       của aef-fsb.js là một graphql MUTATION (cartCreate) nhưng không mang cookie nên
       không chạm được giỏ khách — bỏ dòng đó thì luật graphql coi nó là lượt ghi và mỗi
       cú bấm đẻ thêm 1–2 GET /cart.js.
       Người gác: scripts/test-mot-cu-bam-mot-luot-hoi-gio.js (⑩ nhiễu số liệu · ⑪ TƯƠI-3). */
    function laCauHoiGraphql(init) {
      const b = init && init.body;
      if (typeof b !== 'string') return false;
      let q;
      try { q = JSON.parse(b).query; } catch (e) { return false; }
      if (typeof q !== 'string') return false;
      /* Một tài liệu có thể mang NHIỀU operation, operationName chọn cái nào chạy:
         "query A{…} mutation B{cartLinesAdd…}" + operationName "B" là một lượt GHI dù mở
         đầu bằng `query`. Có chữ `mutation` ở bất kỳ đâu ⇒ coi là "có thể đổi" (nhầm một
         tên trường/chuỗi chứa chữ đó chỉ tốn thêm một lượt mạng). */
      if (/\bmutation\b/.test(q)) return false;
      q = q.replace(/^(\s*#[^\n]*\n)*\s*/, '');
      return /^(query\b|\{)/.test(q);
    }
    function coTheDoiGio(d, m, init) {
      if (d && d.khac) return false;
      /* credentials:'omit' = không cookie ⇒ không chạm được giỏ của khách. Đó là
         câu hỏi phí ship qua GIỎ PHỤ Storefront của aef-fsb.js (vòng 53, L1):
         tính nó là lượt ghi thì mỗi cú bấm đẻ thêm 1–2 GET /cart.js. */
      if (init && init.credentials === 'omit') return false;
      if (d && GHI_GIO.test(d.duong)) return true;
      if (m === 'GET' || m === 'HEAD') return false;
      if (!d) return true;
      if (DUONG_GIO.test(d.duong)) return true;
      if (GRAPHQL.test(d.duong)) return !laCauHoiGraphql(init);
      return false;
    }
    function laDocGio(input, init, d, m) {
      if (!d || d.khac || m !== 'GET' || d.hoi || !DOC_GIO.test(d.duong)) return false;
      if (typeof input !== 'string' && !(typeof URL === 'function' && input instanceof URL)) return false;
      const o = init || {};
      return !(o.signal || o.body != null || o.credentials === 'omit');
    }
    function banSao(r) { return r && typeof r.clone === 'function' ? r.clone() : r; }

    window.fetch = function (input, init) {
      const d = diaChi(input);
      const m = phuongThuc(input, init);
      if (laDocGio(input, init, d, m)) {
        if (chung && chung.nhip === nhip) {
          const tuoi = chung.xong === 0 || Date.now() - chung.xong <= CUA_SO_TUOI_MS;
          if (tuoi || (chung.phaDung && trongPhaDung())) {
            thongKe.chung++;
            if (!tuoi) thongKe.phaDung++;
            return chung.p.then(banSao);
          }
        }
        /* no-store cho lượt đem dùng chung: người gọi mini-cart/card-stepper đòi
           no-store, lượt của họ có thể được trả bằng lượt do người khác mở. */
        const p = goc.call(this, input, Object.assign({}, init || {}, { cache: 'no-store' }));
        const muc = { nhip: nhip, p: p, xong: 0, phaDung: nhip === 0 && trongPhaDung() };
        chung = muc;
        thongKe.mang++;
        p.then(function (r) {
          if (nguoiNghe.length) phatAnh(r, muc.nhip, nguoiNghe.slice());
          if (chung !== muc) return;
          if (r && r.ok) muc.xong = Date.now(); else chung = null;
        }, function () { if (chung === muc) chung = null; });
        return p.then(banSao);
      }
      if (coTheDoiGio(d, m, init)) {
        tangNhip();
        dangGhi++;
        const pg = goc.apply(this, arguments);
        /* Gắn TRƯỚC khi trả về ⇒ chạy trước mọi .then của bên gọi và của hai bộ
           bọc ngoài (aef-fsb, cart-card-indicator): nhịp đã tăng trước khi bất
           kỳ ai kịp hẹn giờ đi hỏi lại. */
        const xongGhi = function () { dangGhi = Math.max(0, dangGhi - 1); };
        pg.then(function () { xongGhi(); tangNhip(); }, function () { xongGhi(); tangNhip(); docLaiSauGhiHong(); });
        return pg;
      }
      return goc.apply(this, arguments);
    };

    ['cart:updated', 'cart:item-added', 'product:added-to-cart', 'cart:added'].forEach(function (ev) {
      window.addEventListener(ev, tangNhip, true);
    });
    /* 1/11/2026 (fix-gio) — trang về từ bfcache: lượt GET còn bay từ trước lúc đóng băng mang giỏ cũ, không được
       đem dùng chung cho người hỏi sau đó. Người gác: T2b của scripts/test-gio-luot-cu-khong-ve-de.js */
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) tangNhip(); }, true);
  })();
})();

;

/* ===== zone-detection.js ===== */
// Zone detection — resolves visitor shipping zone for AE Foodstore.
// Priority chain (BUG-P fix 2026-05-17 — user-entered ZIP now beats stale cache):
//   0. localStorage.ae_zip_code (set by ae-delivery-widget) → derive state via
//      zipToState() prefix table — authoritative when user has explicitly set ZIP
//   1. cart.shipping_address.province_code (real shipping address from checkout)
//   2. localStorage cache (30d TTL) — invalidated on read if postal != ae_zip_code
//   3. Shopify.country check (hide bar if non-US)
//   4. ipapi.co fetch (state + zip from IP)
//   5. Fallback: us_far ($79 conservative)
// Dispatches `ae-zone-ready` event with detail { zone, threshold, label, source }.
// Listens for `aef:zone-changed` to re-resolve in-page (no reload) when widget
// captures a new ZIP. Bot detection skips ipapi. Failure: 3 fails → 24h cooldown.
(function () {
  'use strict';

  /* 28/9/2026 (vòng 53, đợt 4) — 'dfw' là vùng TIỀN (dải ZIP 75001–76299, ngưỡng $59 như
     tx_local). Trước hôm nay nhãn của nó tự nhận "FREE local delivery" + "Same-day delivery"
     cho cả dải — mà Local Delivery thật là 30 dặm quanh Arlington (Admin; đo giỏ phụ 28/9:
     75023 Plano · 76201 Denton · 75069 McKinney · 76048 Granbury CHỈ có Standard) và giao
     trong ngày là tier1 20 dặm. Hai lời hứa ấy KHÔNG phải của bảng này:
       · "giao tận nơi" — MỘT nguồn: câu trả lời của Shopify cho đúng ZIP (giỏ phụ
         Storefront, assets/aef-fsb.js nhanTheoShopify);
       · "trong ngày" — tier khoảng cách của assets/ae-delivery-widget.js (TIER_DEFS).
     Người gác: scripts/test-nhan-giao-tan-noi-theo-shopify.js CA M + N. */
  const ZONES = {
    dfw:         { threshold: 5900, label: 'FREE shipping',       sub: '' },
    tx_local:    { threshold: 5900, label: 'FREE shipping',       sub: '' },
    us_standard: { threshold: 6900, label: 'FREE shipping',       sub: '' },
    us_far:      { threshold: 7900, label: 'FREE shipping',       sub: '' },
    remote:      { threshold: null, label: 'USPS calculated rate', sub: '' },
    /* 28/9/2026 (vòng 53, đợt 4) — VÙNG KHÔNG GIAO. Checkout của Shopify ra 0 cách giao
       cho các mã này (đo giỏ phụ Storefront 28/9: 96910 · 96950 · 96799 · 00802 · 09021 ·
       96201 · 34002 — không giá tĩnh, không giá hãng; AK/HI/PR thì có USPS). Chính sách
       /policies/shipping-policy §1: "We don't currently ship to other U.S. territories … or
       to APO/FPO/DPO". `giao: false` là CỜ DUY NHẤT mọi nơi khác đọc để trả lời "vùng này
       có giao không" (viên giao hàng, thanh free-ship, ô kiểm ZIP trang same-day) — đừng
       so tên vùng, đừng chép danh sách mã. Câu khách đọc nằm ở từ điển của
       ae-delivery-widget.js ('zone.khong_giao'), không ở đây: label rỗng là cố ý.
       Người gác: scripts/test-vung-khong-giao-mot-nguon.js (①) ·
       scripts/test-vung-khong-giao-khop-shopify.js (③, hỏi Shopify thật). */
    khong_giao:  { threshold: null, label: '', sub: '', giao: false },
  };

  /* TX Local: TX, OK ($59) */
  /* US Standard: 25 states ($69) */
  /* US Far Extended: 22 states ($79) */
  /* Remote: AK, HI, PR (USPS tính theo cân) */
  /* Không giao: USVI, Guam, Bắc Marianas, American Samoa, APO/FPO/DPO (AA · AE · AP) */
  const STATE_ZONE = {
    'TX': 'tx_local', 'OK': 'tx_local',
    /* 19/9/2026 — 10 bang dưới đây ĐÃ ĐO LẠI bằng /cart/shipping_rates.json trên
       cửa hàng THẬT (7 mốc tiền), vì bảng cũ xếp sai theo CẢ HAI CHIỀU:
         MI WI MN ND SD : bảng cũ ghi us_far ($79) — THẬT là $69
                          (thu $8,99 tới giỏ $66,30 · miễn từ $70,20)
         NJ PA MD DE DC : bảng cũ ghi us_standard ($69) — THẬT là $79
                          (thu $10,99 tới giỏ $78,89 · miễn từ $81,90)
       Đối chứng hai đầu: TX thu tới $58,50 miễn từ $60,28 ($59, bảng ĐÚNG) ·
       NY thu tới $78,89 miễn từ $81,90 ($79, bảng ĐÚNG) ⇒ thước không kẹt.
       Loại trừ "thước CÂN chứ không phải thước TIỀN": giỏ $79,78 NẶNG HƠN
       (6.883g · 22 món) lại được MIỄN, giỏ $78,00 nhẹ hơn (6.804g · 20 món)
       vẫn bị thu. Nặng hơn mà rẻ hơn ⇒ thước TIỀN.

       Chiều NJ/PA/MD/DE/DC là chiều ĐẮT: khách đọc "free từ $69", thanh
       free-ship còn thúc họ gom thêm cho đủ, tới $70–$78 tưởng xong thì bị
       tính thêm $10,99 ngay ở trang trả tiền.

       ⚠️ VÌ SAO NẤP ĐƯỢC LÂU: isBot() cho trình duyệt headless rơi thẳng vào
       phương án dự phòng us_far ($79) — mà $79 TÌNH CỜ đúng cho NJ/PA/… Nên
       mọi bộ đo mở headless rồi đọc thanh free-ship đều thấy "$79+" và báo
       XANH OAN. Phải che cờ navigator.webdriver mới nhìn thấy lỗi.

       🔴 NGUỒN SỰ THẬT là HỒ SƠ VẬN CHUYỂN trong Shopify admin, KHÔNG phải
       bảng này. Sửa hồ sơ thì phải đo lại rồi sửa cả đây — một khái niệm hai
       nguồn dữ liệu. [[feedback_one_concept_two_sources]] */
    'MI': 'us_standard', 'WI': 'us_standard', 'MN': 'us_standard',
    'ND': 'us_standard', 'SD': 'us_standard',
    'NJ': 'us_far', 'PA': 'us_far', 'MD': 'us_far',
    'DE': 'us_far', 'DC': 'us_far',
    'AR': 'us_standard', 'LA': 'us_standard', 'MS': 'us_standard',
    'AL': 'us_standard', 'TN': 'us_standard', 'KY': 'us_standard',
    'MO': 'us_standard', 'KS': 'us_standard', 'IA': 'us_standard',
    'IL': 'us_standard', 'IN': 'us_standard', 'OH': 'us_standard',
    'GA': 'us_standard', 'FL': 'us_standard', 'SC': 'us_standard',
    'NC': 'us_standard', 'VA': 'us_standard', 'WV': 'us_standard',
    'NM': 'us_standard', 'NE': 'us_standard',
    'CA': 'us_far', 'OR': 'us_far', 'WA': 'us_far',
    'NV': 'us_far', 'ID': 'us_far', 'UT': 'us_far',
    'AZ': 'us_far', 'CO': 'us_far', 'WY': 'us_far',
    'MT': 'us_far',
    'NY': 'us_far', 'CT': 'us_far', 'RI': 'us_far',
    'MA': 'us_far', 'VT': 'us_far', 'NH': 'us_far',
    'ME': 'us_far',
    /* AK/HI/PR: USPS tính theo cân, không có ngưỡng free-ship */
    'AK': 'remote', 'HI': 'remote', 'PR': 'remote',
    /* 🔴 vòng 48, 14/9/2026 — GUAM · BẮC MARIANA · SAMOA · ba dải QUÂN ĐỘI cũng
       KHÔNG có ngưỡng, nhưng bảng này chỉ có 4 dòng remote nên tất cả rơi vào
       `STATE_ZONE[state] || FALLBACK_ZONE` = us_far ⇒ họ đọc "FREE shipping on
       orders $79+" y như khách Texas. Chính schema của
       sections/aef-brand-flavors.liquid:907 đã kể tên Guam là "vùng không có
       ngưỡng" — lời văn có, bảng thì không (một khái niệm, hai nguồn dữ liệu).
       Số thật, vòng soi 14/9 đo bằng ShopifyQL 365 ngày: Guam 2 đơn, Armed
       Forces Europe 2 đơn. Ít khách, nhưng với họ thì lời hứa gãy 100%.

       28/9/2026 (vòng 53, đợt 4) — bảy mã dưới đây HIỆN KHÔNG GIAO (checkout ra 0
       cách giao). Trước đó chúng nằm ở 'remote' ⇒ viên giao hàng hứa "📦 Delivery
       date at checkout", thanh free-ship hứa "Shipping calculated at checkout
       (USPS…)" — hứa một chuyến giao không tồn tại, trái §1 chính sách.
       🔑 MỞ LẠI (Boss: sau khi sửa cân nặng) = ĐỔI ĐÚNG CÁC DÒNG NÀY sang 'remote'
          (mở từng mã cũng được — mỗi mã là một cặp khoá riêng). Không nơi nào khác giữ danh
          sách: viên giao hàng / thanh free-ship / trang same-day hỏi cờ `giao` của
          vùng qua window.AE_ZONE hoặc window.aeZoneForZip(). Mở xong làm tiếp, và bộ
          nào canh bước nào (9/10/2026 — đo bằng cách mở lại Guam, rồi cả 4 lãnh thổ):
            1. dựng lại assets/aef-head.js (node scripts/build-js-bundles.js) —
               test-ban-gop-khop-nguon.js đỏ nếu quên;
            2. sửa câu <p data-aef-khong-giao> + dòng Remote (EN + VI) của
               templates/page.shipping-policy.liquid — test-trang-chinh-sach-khop-bang-vung.js,
               test-vung-khong-giao-mot-nguon.js và PHẦN C của test-lp-sameday-khong-hua-bua.js
               đỏ tới khi trang và bảng khớp;
            3. hồ sơ vận chuyển trong Admin — bộ ③ test-vung-khong-giao-khop-shopify.js đỏ
               khi bảng này và checkout nói khác nhau;
            4. /policies/shipping-policy (Admin → Settings → Policies) — bộ ③
               test-noi-cua-tiem-khop-cua-hang.js CA 9 đỏ khi nó nói khác trang theme.
          Làm đủ bốn bước mà còn bộ nào đỏ thì bộ đó đang CHÉP TAY danh sách — sửa bộ đó,
          đừng sửa bảng. */
    'VI': 'khong_giao',
    'GU': 'khong_giao', 'MP': 'khong_giao', 'AS': 'khong_giao',
    'AA': 'khong_giao', 'AE': 'khong_giao', 'AP': 'khong_giao',
  };

  const FALLBACK_ZONE = 'us_far';

  /* 🔴 vòng 48, 14/9/2026 — NĂM mã ISO này là LÃNH THỔ MỸ, không phải "nước khác".
   *
   * ipapi.co trả chúng ở `country_code`, KHÔNG ở `region_code` — đo thật với IP
   * Puerto Rico 66.50.0.1: {country:"PR", country_code:"PR", region_code:null,
   * postal:"00692"}. Nên dòng "không phải US thì thôi" trong detectFromIpapi()
   * vứt luôn cả `postal` ⇒ resolve() rơi xuống FALLBACK_ZONE = us_far = $79, và
   * vì nhánh fallback không mang state/postal nên lưới an toàn
   * của thanh free-ship (khi đó hỏi /cart/shipping_rates.json; từ 27/9/2026 là
   * giỏ phụ Storefront trong assets/aef-fsb.js — vẫn cần state/postal) cũng
   * không chạy nốt. Hai lớp cùng im.
   *
   * ⚠️ DANH SÁCH NÀY PHẢI ĐÓNG. Đừng nới thành "trả country_code cho mọi nước":
   *    mã ISO của Canada là 'CA' — trùng đúng mã bang California trong
   *    STATE_ZONE ⇒ khách Canada sẽ được hứa $79 "có căn cứ" thay vì rơi
   *    fallback. Cùng bẫy: MP/MD/MO/AE. Mọi mã trong danh sách này BẮT BUỘC
   *    phải được STATE_ZONE xếp vào một vùng KHÔNG ngưỡng ('remote' — có giao, USPS
   *    tính theo cân — hoặc 'khong_giao' từ 28/9); scripts/test-lanh-tho-my-khong-nhan-nguong.js
   *    đọc cả hai bảng và đỏ ngay nếu lệch.
   *
   * (Nhánh Shopify.country ở bước 3 KHÔNG cứu được họ: shop chỉ một market nên
   *  Shopify.country luôn là "US" — curl trang chủ và ?country=PR đều ra "US",
   *  browsing_context_suggestions.json chỉ liệt kê đúng một nước. Bước 3 là mã
   *  chưa từng chạy; đường cứu thật là chỗ này.) */
  const LANH_THO_MY_ISO = ['PR', 'VI', 'GU', 'MP', 'AS'];

  /* ── MỘT NGUỒN SỰ THẬT cho câu hỏi "chưa biết vùng thì nói ngưỡng nào?" ──────
   *
   * File này đã trả lời từ lâu: FALLBACK_ZONE = us_far = $79. Mọi đường trong
   * resolve() đều kết thúc bằng một dispatch, kể cả nhánh bot và nhánh hỏng —
   * nên AE_ZONE không bao giờ đứng rỗng vĩnh viễn, và khi không có tín hiệu gì
   * thì nó là $79.
   *
   * Nhưng HAI chỗ khác lại tự trả lời khác:
   *   · ae-delivery-widget.js  fillAmount() đệm '$59' trong lúc chờ resolve
   *   · announcement-bar.liquid đệm '$59' ngay từ máy chủ
   * ⇒ khách chưa nhập ZIP đọc "$59", một lát sau đổi thành "$79". Đó là hứa RẺ
   * hơn thật rồi rút lại — đúng chiều mất lòng tin, và nó chạm 100% khách vào
   * lần đầu. Số thật: CA 148 đơn · NY 80 · TX chỉ 79 ⇒ đa số khách web NẰM ở
   * vùng $79, tức đa số đọc phải con số sai.
   *
   * Phơi hằng số ra window để hai chỗ kia ĐỌC thay vì tự dán. Liquid không đọc
   * được JS nên bên đó vẫn phải gõ số — người gác test-nguong-mac-dinh.js so
   * hai con số với nhau và đỏ ngay khi chúng lệch.
   * ------------------------------------------------------------------------- */
  const CACHE_KEY = 'ae_zone_v1';
  const ZIP_KEY = 'ae_zip_code';
  const CACHE_TTL = 30 * 24 * 60 * 60 * 1000;
  const FAIL_KEY = 'ae_zone_fail_v1';
  const FAIL_LIMIT = 3;
  const FAIL_COOLDOWN = 24 * 60 * 60 * 1000;

  /* BUG-P fix: US ZIP code first-3-digit → state mapping. The ae-delivery-widget
     captures a ZIP via UI but doesn't know the state directly (only tier 1–5 by
     distance). We need the state to look up the correct zone via STATE_ZONE.
     Sources: USPS ZIP code zone allocations + Wikipedia US ZIP prefix tables.
     Ranges are inclusive on both ends. First-match wins; ordered by prefix. */
  const ZIP_PREFIX_RANGES = [
    /* 🔴 Trước là [5, 8, 'NY'] — gộp cả 006/007/008 vào New York. Hậu quả: khách
       Puerto Rico và US Virgin Islands được hứa "FREE shipping cho đơn từ $79",
       trong khi PR/USVI đi USPS tính theo cân và KHÔNG có ngưỡng nào. Đó là lời
       hứa tiệm không giữ được — khách đặt $80 rồi tới checkout mới thấy phí ship.
       USPS thật: 005 = NY (Holtsville) · 006/007/009 = PR · 008 = USVI. */
    [5,   5,   'NY'], [6,   7,   'PR'], [8,   8,   'VI'], [9,   9,   'PR'],
    [10,  27,  'MA'], [28,  29,  'RI'],
    [30,  38,  'NH'], [39,  49,  'ME'], [50,  59,  'VT'], [60,  69,  'CT'],
    [70,  89,  'NJ'],
    /* 🔴 vòng 48, 14/9/2026 — ba dải ZIP QUÂN ĐỘI (APO/FPO). 090–098 = AE
       (Armed Forces Europe), 962–966 = AP (Pacific), 340 = AA (Americas). Hai
       dải đầu trước nay rơi RA NGOÀI bảng ⇒ null ⇒ FALLBACK_ZONE = $79; còn 340
       thì tệ hơn: nó bị dòng [320, 349, 'FL'] nuốt thành FLORIDA ⇒ us_standard
       $69. Đối chứng lấy từ dữ liệu của chính kho, scripts/data/zip-centroids.json:
       34002 → [8.9733, -79.5556] = Panama City, không phải Naples FL (34101 →
       [26.1423, -81.796] mới là FL thật). */
    [90,  98,  'AE'],
    [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'],
    /* 🔴 vòng 53, 25/9/2026 — trước là [200, 205, 'DC'], gộp luôn tiền tố 201
       vào DC. USPS: 201 = SCF Dulles, VIRGINIA (Ashburn · Chantilly · Herndon ·
       Reston · Leesburg · Manassas · Sterling). Hậu quả: khách gõ 201xx đọc
       "free từ $79" của DC trong khi Shopify miễn từ $69 của VA — đo LIVE, cùng
       46 món 3.450 g: 20151/VA thu $8.99 ở giỏ $68.54, MIỄN ở giỏ $69.04 (y hệt
       22201); hỏi 20151 với province=DC thì Shopify trả 422 "Enter a valid ZIP
       code for Washington DC" ⇒ lưới hỏi giá thật của aef-fsb.js cũng tắt.
       Nằm im từ 16/7 vì trước 19/9 DC và VA cùng $69. Canh ở
       scripts/test-zone-for-zip.js. */
    [200, 200, 'DC'], [201, 201, 'VA'], [202, 205, 'DC'],
    [569, 569, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'], [247, 268, 'WV'],
    [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'],
    [320, 339, 'FL'], [340, 340, 'AA'], [341, 349, 'FL'],
    [350, 369, 'AL'], [370, 385, 'TN'], [386, 397, 'MS'], [398, 399, 'GA'],
    [400, 427, 'KY'], [430, 459, 'OH'], [460, 479, 'IN'], [480, 499, 'MI'],
    [500, 528, 'IA'], [530, 549, 'WI'], [550, 567, 'MN'], [570, 577, 'SD'],
    [580, 588, 'ND'], [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'],
    [660, 679, 'KS'], [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'],
    [730, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'],
    [832, 838, 'ID'], [840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'],
    /* 885xx là EL PASO, TEXAS — nằm tách khỏi dải 79xxx quen thuộc nên rất dễ
       bỏ sót, và bỏ sót thì rơi vào FALLBACK_ZONE = us_far ⇒ khách Texas bị đòi
       $79 thay vì $59. Lỗ trong bảng không làm trang vỡ, nó chỉ lặng lẽ đòi thêm
       tiền. */
    [885, 885, 'TX'],
    /* 969xx = GUAM + BẮC MARIANA. Bảng cũ nhảy thẳng [967,968,'HI'] → [970,979,'OR']
       nên khách Guam có CHỦ ĐỘNG gõ ZIP vào ô giao hàng cũng vẫn ra null ⇒ $79:
       vùng DUY NHẤT không có đường nào ra `remote`. (vòng 48, 14/9/2026) */
    [889, 898, 'NV'], [900, 961, 'CA'], [962, 966, 'AP'], [967, 968, 'HI'],
    [969, 969, 'GU'], [970, 979, 'OR'],
    [980, 994, 'WA'], [995, 999, 'AK']
  ];

  /* 28/9/2026 (vòng 53, đợt 4) — MÃ ZIP RIÊNG mà TIỀN TỐ 3 SỐ đọc sai nơi.
     · 96799 là ZIP DUY NHẤT của American Samoa, nằm trong tiền tố 967 của Hawaii ⇒
       bảng tiền tố đọc ra 'HI' (vùng remote, có giao USPS) trong khi Samoa checkout ra
       0 cách giao. Cùng một người gõ ZIP nhà mình ở Pago Pago mà viên giao hàng hứa
       "Delivery date at checkout".
     · 96950–96952 là Bắc Marianas (Saipan · Tinian · Rota), nằm trong tiền tố 969 của
       Guam. Hôm nay hai nơi cùng vùng nên không lệch gì; tách ra để ngày MỞ LẠI từng
       mã (STATE_ZONE) không kéo theo nơi kia.
     Xét TRƯỚC bảng tiền tố. Nguồn: USPS Publication 65 (ZIP của lãnh thổ). */
  const ZIP_RIENG = { '96799': 'AS', '96950': 'MP', '96951': 'MP', '96952': 'MP' };

  function zipToState(zip) {
    if (!zip) return null;
    const z = String(zip).trim();
    if (!/^\d{5}$/.test(z)) return null;
    if (Object.prototype.hasOwnProperty.call(ZIP_RIENG, z)) return ZIP_RIENG[z];
    const p3 = parseInt(z.substring(0, 3), 10);
    for (let i = 0; i < ZIP_PREFIX_RANGES.length; i++) {
      const r = ZIP_PREFIX_RANGES[i];
      if (p3 >= r[0] && p3 <= r[1]) return r[2];
    }
    return null;
  }

  /* 🔴 vòng 53, 25/9/2026 — ZIP KHÁCH GÕ PHẢI SỐNG ĐƯỢC KHI localStorage HỎNG.
     Trước đây nơi DUY NHẤT nhớ "khách đã tự gõ ZIP" là localStorage.ae_zip_code.
     Trình duyệt chặn dữ liệu trang (getter ném SecurityError), kho đầy (setItem
     ném QuotaExceededError), WebView tắt DOM storage (localStorage = null) ⇒
     safeSet của widget ghi hỏng trong im lặng, listener `aef:zone-changed` bên
     dưới gọi resolve(), bước 0 đọc ra null ⇒ rơi xuống ipapi ⇒ `ae-zone-ready`
     mang ZIP theo IP ⇒ viên lật về ZIP đó ngay sau chữ "Saved", ngày giao và
     thanh free-ship theo bang khác. Đo jsdom: IP 75201, khách gõ 10001 ⇒ ra
     dfw/$59/ipapi thay vì us_far/$79/user-zip.

     Sự kiện vốn MANG SẴN detail.zip, chỉ là không ai đọc. Nay listener ghi nó
     vào biến này và readSavedZip() hỏi biến TRƯỚC localStorage: biến là hành
     động MỚI NHẤT của khách trong trang, còn lúc kho đầy localStorage vẫn có thể
     giữ ZIP CŨ (ghi mới hỏng, đọc cũ vẫn chạy).
     Vẫn một nguồn: cachedPostal() của widget và fillZip() của ngăn giỏ tự rơi về
     window.AE_ZONE.postal khi localStorage ném lỗi — AE_ZONE giờ mang đúng ZIP này.
     (Riêng ca kho đầy còn ZIP cũ, hai hàm đó hỏi localStorage TRƯỚC nên vẫn có thể
     đọc ra ZIP cũ — chưa vá ở lượt này.)
     Giới hạn: biến chỉ sống trong một trang; sang trang khác là về lại ZIP theo
     IP (ca phổ biến nhất chặn luôn cả cookie, không còn chỗ nào để nhớ).
     ⚠️ CHỈ gán ở listener `aef:zone-changed` (đường khách BẤM GỬI). Đừng gán ở
        đường silent / `ae-zone-ready` — đó là vòng lặp đóng băng P0 17/5.
     Canh ở scripts/test-zip-khach-go-song-khi-luu-tru-hong.js. */
  let zipKhachGo = null;

  function readSavedZip() {
    if (zipKhachGo) return zipKhachGo;
    try {
      const z = localStorage.getItem(ZIP_KEY);
      return z && /^\d{5}$/.test(z) ? z : null;
    } catch (e) { return null; }
  }

  function isBot() {
    if (navigator.webdriver) return true;
    /* 20/9/2026 — khuôn cũ tìm CHUỖI CON: /bot|crawl|spider|…/. Đo bằng
       jsdom: UA 'Mozilla/5.0 (Linux; Android 13; CUBOT_NOTE_40) …' dính vì
       'CUBOT' có 'bot' ⇒ khách thật rơi vào FALLBACK_ZONE ($79) trong khi
       bang của họ có thể là $59 hay $69. Chiều hại là đòi NHIỀU hơn thật:
       không mất lòng tin về tiền, nhưng mất đơn, và không ai báo.
       Nay đòi RANH GIỚI hai bên. Các tên riêng dài (googlebot, bingbot…) giữ
       nguyên vì chúng tự là một từ. [[reference_js_ranh_gioi_tu_khong_hieu_dau]] */
    const ua = String(navigator.userAgent || '');
    if (/(^|[^a-z])(bot|crawl|crawler|spider|headless)([^a-z]|$)/i.test(ua)) return true;
    return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|applebot|facebookexternalhit/i.test(ua);
  }

  function isDFW(state, postal) {
    if (state !== 'TX' || !postal) return false;
    const z = parseInt(String(postal).slice(0, 5), 10);
    return z >= 75001 && z <= 76299;
  }

  function resolveZoneKey(state, postal) {
    if (isDFW(state, postal)) return 'dfw';
    return STATE_ZONE[state] || FALLBACK_ZONE;
  }

  /* Đặt NGAY, không đợi resolve(): mấy file khác cần trả lời "chưa biết vùng thì
     nói gì" ở đúng cái khoảnh khắc chưa-biết đó. */
  window.AE_ZONE_FALLBACK = {
    zone: FALLBACK_ZONE,
    threshold: ZONES[FALLBACK_ZONE].threshold,
  };

  /* `giao` luôn có mặt trong mọi câu trả lời (true/false) — người đọc hỏi `giao === false`. */
  function dispatch(zoneKey, source, detail) {
    const z = ZONES[zoneKey] || ZONES[FALLBACK_ZONE];
    const payload = Object.assign({}, z, { zone: zoneKey, source: source, giao: z.giao !== false }, detail || {});
    window.AE_ZONE = payload;
    document.dispatchEvent(new CustomEvent('ae-zone-ready', { detail: payload }));
  }

  function loadCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const d = JSON.parse(raw);
      if (Date.now() - d.t > CACHE_TTL) return null;
      /* BUG-P safety net: if the user changed ZIP via the widget after this
         cache was saved, the postal field is stale. Drop the entry so the
         resolve chain falls through to a fresh source. */
      const currentZip = readSavedZip();
      if (currentZip && d.postal && String(d.postal) !== String(currentZip)) {
        try { localStorage.removeItem(CACHE_KEY); } catch (e) {}
        return null;
      }
      return d;
    } catch (e) { return null; }
  }
  function saveCache(state, postal) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), state: state, postal: postal || '' }));
    } catch (e) {}
  }
  function isFailCooled() {
    try {
      const raw = localStorage.getItem(FAIL_KEY);
      if (!raw) return false;
      const d = JSON.parse(raw);
      if (d.count >= FAIL_LIMIT && Date.now() - d.t < FAIL_COOLDOWN) return true;
      return false;
    } catch (e) { return false; }
  }
  /* 🔴 vòng 48, 14/9/2026 — MỐC NGHỈ PHẢI ĐƯỢC LÀM MỚI Ở MỌI LẦN HỎNG.
   *
   * Trước đây dòng giữa là `if (d.count === 1) d.t = Date.now();` — mốc `t` chỉ
   * được ghi ở lần hỏng ĐẦU TIÊN và không bao giờ đổi nữa (count đã > 1), trong
   * khi isFailCooled() ở trên xét `Date.now() - d.t < FAIL_COOLDOWN`. Qua 24 giờ
   * kể từ lần hỏng đầu, vế thời gian sai VĨNH VIỄN ⇒ cơ chế "3 lần hỏng → nghỉ
   * 24 giờ" chặn được đúng MỘT chặng rồi tắt hẳn, dù hỏng lần thứ 4, 40 hay 400.
   * clearFail() chỉ chạy khi ipapi TRẢ VỀ state, mà khách bị uBlock/Brave chặn
   * ipapi.co thì không bao giờ có state ⇒ họ kẹt ở nhánh này mãi mãi. Đúng tập
   * khách mà mốc nghỉ sinh ra để bảo vệ.
   *
   * Đo bằng chính file này (40 lượt tải cách nhau 2 giờ ≈ 3,3 ngày, ipapi luôn
   * hỏng): bản cũ bắn 31/40 request cross-origin, bản này bắn 4/40. Sau chặng
   * nghỉ đầu, mỗi 24 giờ chỉ còn ĐÚNG 1 lượt thử — lượt đó hỏng thì tự làm mới
   * mốc và nghỉ tiếp.
   *
   * ⚠️ CỐ Ý KHÔNG xoá hồ sơ khi quá hạn (ý thứ hai của người soi). Xoá thì count
   *    về 0, phải hỏng lại đủ 3 lần mới nghỉ được ⇒ 3 request/24h thay vì 1.
   *    Hai ý đó đá nhau, chỉ chọn một. Thay vào đó chặn count trôi lên vô hạn
   *    bằng Math.min — hồ sơ trong localStorage đứng yên ở {count:3, t:<mới>}. */
  function recordFail() {
    try {
      const raw = localStorage.getItem(FAIL_KEY);
      const d = raw ? JSON.parse(raw) : { count: 0, t: Date.now() };
      d.count = Math.min((d.count || 0) + 1, FAIL_LIMIT);
      d.t = Date.now();
      localStorage.setItem(FAIL_KEY, JSON.stringify(d));
    } catch (e) {}
  }
  function clearFail() {
    try { localStorage.removeItem(FAIL_KEY); } catch (e) {}
  }

  async function detectFromCart() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      const addr = cart.shipping_address;
      if (addr && addr.province_code) {
        return { state: addr.province_code, postal: addr.zip || '' };
      }
    } catch (e) {}
    return null;
  }

  /* 01/11/2026: gọi ipapi không hạn giờ, dịch vụ treo là resolve() treo theo, thanh free-ship
     không bao giờ có vùng. Quá hạn thì huỷ, đi vào `catch` như mọi lần hỏng, rồi rơi về FALLBACK_ZONE.
     10 giây chứ không 3: khách mạng chậm vẫn phải nhận đúng vùng; hạn ngắn làm họ rơi về $79 không ZIP,
     đếm hỏng tăng, sau 3 lượt ngưng gọi 24 giờ. Treo thật thì recordFail vẫn cho các trang sau đi nhanh. */
  const HAN_IPAPI_MS = 10000;
  async function detectFromIpapi() {
    if (isFailCooled()) return null;
    const ctl = typeof AbortController === 'function' ? new AbortController() : null;
    const hen = ctl ? setTimeout(function () { ctl.abort(); }, HAN_IPAPI_MS) : null;
    try {
      const r = await fetch('https://ipapi.co/json/', ctl ? { mode: 'cors', signal: ctl.signal } : { mode: 'cors' });
      if (!r.ok) throw new Error('ipapi http ' + r.status);
      const d = await r.json();
      /* 🔴 vòng 48, 14/9/2026 — LÃNH THỔ MỸ ĐI TRƯỚC dòng "không phải US thì thôi".
         Với khách PR/VI/GU/MP/AS, ipapi trả country_code là mã lãnh thổ chứ
         không phải 'US', nên dòng dưới vứt luôn cả `postal` và họ rơi xuống
         $79. STATE_ZONE đã xếp sẵn cả năm mã vào vùng không ngưỡng (PR `remote`;
         VI/GU/MP/AS `khong_giao` từ 28/9) nên chỉ cần trả mã đó ra là chuỗi
         resolve tự nói đúng ("phí tính ở bước thanh toán" / "chưa giao tới"), và vì
         có đủ state + postal nên free-shipping-bar còn hỏi được giá ship THẬT.
         Xem chú thích của LANH_THO_MY_ISO ở đầu file — danh sách phải ĐÓNG. */
      const maVung = String(d.country_code || d.country || '').toUpperCase();
      if (LANH_THO_MY_ISO.indexOf(maVung) > -1) {
        clearFail();
        return { state: maVung, postal: d.postal || '' };
      }
      /* 🔴 vòng 48, 14/9/2026 — HAI LỐI THOÁT DƯỚI ĐÂY CŨNG LÀ "MỘT LẦN HỎNG".
         Trước đây chỉ nhánh `catch` mới gọi recordFail(), nên hai đường "fetch
         chạy xong mà KHÔNG lấy được bang" đi qua im lặng: bộ đếm đứng ở 0, mốc
         nghỉ KHÔNG BAO GIỜ bật lên dù một lần, và resolve() rơi xuống
         dispatch(FALLBACK_ZONE,'fallback') nên saveCache() cũng không chạy ⇒
         mỗi lượt tải trang lại một request cross-origin, vĩnh viễn.
           (a) country không phải US — khách Canada/VN. Bước 3 (Shopify.country)
               KHÔNG chắn được vì shop một market, Shopify.country luôn là 'US'.
               ipapi.co lúc hết hạn mức cũng trả HTTP 200 kèm {"error":true,
               "reason":"RateLimited"} KHÔNG có country ⇒ rơi đúng vào đây.
           (b) 200 nhưng region_code rỗng — hay gặp với IP VPN/datacenter.
         Đếm cả hai là hỏng thì sau 3 lượt là nghỉ 24 giờ, giống hệt ca bị chặn.
         Không đổi giá trị trả về nên chuỗi resolve() phía dưới không đổi hành vi
         một chút nào: cả hai đường vốn đã kết thúc ở FALLBACK_ZONE. */
      if (d.country !== 'US' && d.country_code !== 'US') {
        recordFail();
        return { state: null, country: d.country };
      }
      const state = d.region_code || '';
      const postal = d.postal || '';
      if (state) {
        clearFail();
        return { state: state, postal: postal };
      }
      recordFail();
    } catch (e) {
      recordFail();
    } finally {
      if (hen) clearTimeout(hen);
    }
    return null;
  }

  /* 🔴 23/10/2026 (vòng 53, đợt 5b, GG7-A3) — LƯỢT MỚI NHẤT THẮNG; ZIP KHÁCH GÕ KHÔNG BỊ LƯỢT ĐOÁN VỀ MUỘN ĐÈ.
     resolve() có hai chỗ chờ (/cart.js ở bước 1, ipapi ở bước 4). Khách lần đầu gõ ZIP trong lúc lượt
     tải trang còn chờ ⇒ listener `aef:zone-changed` chạy một lượt MỚI (bước 0, đồng bộ, đúng ZIP khách),
     rồi lượt CŨ về sau vẫn saveCache + dispatch ⇒ đè. Đo jsdom trên mã cũ (người soi 18/10 + người gác
     dưới): ipapi về muộn TX đè 90001 ⇒ "$59" thay "$79"; ipapi HỎNG / RateLimited muộn ⇒ AE_ZONE về
     fallback (postal rỗng, $79 cho khách 75201); giỏ có địa chỉ về muộn đè 90001; khách gõ 96910 (không
     giao) bị đè thành dfw "Add $59.00". Nay mỗi lượt cầm số thứ tự; sau MỖI chỗ chờ, lượt nào không còn
     là lượt mới nhất thì im (không ghi cache, không phát sự kiện). Không thêm sự kiện nào ⇒ không mở lại
     vòng đóng băng P0 17/5. Lượt đoán vẫn được áp khi khách KHÔNG gõ gì (không có lượt mới hơn).
     ⚠️ Mọi `await` thêm vào resolve() sau này phải có dòng kiểm `luot !== soLuot` ngay sau nó.
     Người gác: scripts/test-zone-luot-doan-muon-khong-de-zip-khach.js (K0–K6 + N0). */
  let soLuot = 0;

  async function resolve() {
    const luot = ++soLuot;
    /* 🔴 20/9/2026 — THỨ TỰ NÀY CÓ CHỦ Ý, đừng đảo lại.
       Bản cũ hỏi isBot() TRƯỚC bước 0. Hậu quả đo được bằng jsdom: với
       ae_zip_code='75201' và navigator.webdriver=true, thanh free-ship nói
       us_far $79 (source=bot) trong khi window.aeZoneForZip('75201') —
       thứ sections/lp-sameday.liquid và assets/ae-delivery-widget.js gọi —
       nói dfw $59. Hai con số cùng ra màn hình, cùng một lúc, cho cùng một
       người. aeZoneForZip() KHÔNG hỏi isBot, nên nó không bao giờ khớp được
       với đường bot; chỗ phải nhường là đường này.
       Người đã CHỦ ĐỘNG gõ ZIP thì không phải trình thu thập. Và nhánh bước
       0 không gọi mạng, nên cho nó chạy trước không mở cửa nào cho crawler.
       [[feedback_one_concept_two_sources]] */

    /* 0. User-entered ZIP (BUG-P fix). If the visitor used the delivery
       widget to pick a ZIP, that's the most explicit signal of intent —
       trust it over cached IP guesses. zipToState() handles the 50-state
       prefix lookup; if the ZIP falls outside any known US range, fall
       through to the cart/cache/IP chain. */
    const userZip = readSavedZip();
    if (userZip) {
      const userState = zipToState(userZip);
      if (userState) {
        saveCache(userState, userZip);
        dispatch(resolveZoneKey(userState, userZip), 'user-zip', { state: userState, postal: userZip });
        return;
      }
    }

    /* Hết bước 0: khách không gõ ZIP nào thì từ đây trở xuống là đoán —
       cache, giỏ, IP. Trình thu thập dừng ở đây, nhận ngưỡng dự phòng. */
    if (isBot()) {
      dispatch(FALLBACK_ZONE, 'bot');
      return;
    }

    /* 1. Cart shipping address */
    const cart = await detectFromCart();
    if (luot !== soLuot) return; /* có lượt mới hơn (khách vừa gõ ZIP) — xem khối trên `let soLuot` */
    if (cart && cart.state) {
      saveCache(cart.state, cart.postal);
      dispatch(resolveZoneKey(cart.state, cart.postal), 'cart', { state: cart.state, postal: cart.postal });
      return;
    }

    /* 2. localStorage cache (loadCache also invalidates if postal != ae_zip_code) */
    const cached = loadCache();
    if (cached && cached.state) {
      dispatch(resolveZoneKey(cached.state, cached.postal), 'cache', { state: cached.state, postal: cached.postal });
      return;
    }

    /* 3. Shopify.country */
    if (window.Shopify && Shopify.country && Shopify.country !== 'US') {
      /* 🔴 18/8/2026 — PR / VI KHÔNG được rơi vào nhánh $79.
       *
       * Shopify trả country = 'PR' (Puerto Rico) và 'VI' (US Virgin Islands) như
       * hai nước riêng, nên chúng lọt vào nhánh "non-US" này và nhận
       * FALLBACK_ZONE = us_far = ngưỡng $79. Nhưng STATE_ZONE:48 đã xếp đúng cả
       * hai là `remote` — vùng KHÔNG CÓ ngưỡng free-ship, USPS tính theo cân.
       *
       * Hậu quả: khách PR đọc "Free shipping on orders $79+" trên MỌI trang, mua
       * đủ $79, rồi tới checkout thấy vẫn bị tính cước. Đo thật 18/8 với giỏ
       * $199,80: HI 96801 / AK 99501 / PR 00901 chỉ trả Ground Advantage $8.13 và
       * Priority $15.22 — KHÔNG hề có lựa chọn $0; trong khi TX/CA cùng giỏ đó có
       * $0. Và đây không phải ca hiếm: 5/250 đơn gần nhất là PR.
       *
       * Đây là đường chạy BÌNH THƯỜNG, không cần ipapi hỏng mới dính. */
      const maNuoc = String(Shopify.country).toUpperCase();
      if (maNuoc === 'PR' || maNuoc === 'VI') {
        /* Vùng lấy từ STATE_ZONE (PR 'remote' · VI 'khong_giao' từ 28/9), không gõ tên vùng. */
        dispatch(STATE_ZONE[maNuoc] || 'remote', 'non-us-remote', { state: maNuoc });
        return;
      }
      dispatch(FALLBACK_ZONE, 'non-us', { state: null });
      return;
    }

    /* 4. ipapi.co */
    const ip = await detectFromIpapi();
    if (luot !== soLuot) return; /* như trên — lượt đoán về muộn không đè lượt mới hơn */
    if (ip && ip.state) {
      saveCache(ip.state, ip.postal);
      dispatch(resolveZoneKey(ip.state, ip.postal), 'ipapi', { state: ip.state, postal: ip.postal });
      return;
    }

    /* 5. Fallback */
    dispatch(FALLBACK_ZONE, 'fallback');
  }

  /* BUG-P fix: when ae-delivery-widget captures a new ZIP it dispatches
     `aef:zone-changed` after invalidating the stale `ae_zone_v1` cache.
     Re-running resolve() picks up the new ZIP via the priority-0 step
     and re-fires `ae-zone-ready` — free-shipping-bar, mini-cart popup,
     and any other listener re-render with the correct threshold. */
  window.addEventListener('aef:zone-changed', function (e) {
    try {
      /* ZIP khách vừa gửi — xem khối chú thích ngay trên readSavedZip(). */
      const z = e && e.detail ? String(e.detail.zip || '') : '';
      if (/^\d{5}$/.test(z)) zipKhachGo = z;
      resolve();
    } catch (err) {}
  });

  /* Expose a manual re-resolve hook so other code paths can request a
     fresh zone after they've updated `ae_zip_code` in localStorage. */
  window.aeZoneResolve = function () { try { resolve(); } catch (e) {} };

  /* Tra vùng + ngưỡng của MỘT mã ZIP cụ thể, THUẦN ĐỌC.
   *
   * Không ghi window.AE_ZONE, không phát `ae-zone-ready`, không đụng DOM, không
   * ghi localStorage. Có mặt để trang nào cần trả lời câu "ZIP này ngưỡng bao
   * nhiêu / có giao trong ngày không" mà KHỎI phải tự dán số hay tự định nghĩa
   * lại khoảng ZIP.
   *
   * ⚠️ Đừng dùng aeZoneResolve() cho việc này: hàm đó ĐỔI vùng đang áp cho khách,
   *    kéo theo thanh free-ship và mọi câu {zone_amount} tính lại. Hỏi một câu
   *    không được phép làm đổi trạng thái.
   *
   * Lý do sinh ra: sections/lp-sameday.liquid từng tự xét `/^7[56]\d{3}$/` là DFW
   * (75000–76999) trong khi isDFW() ở đây là 75001–76299 — nên ZIP 76300–76999
   * được hứa giao trong ngày dù hệ thống xếp họ là tx_local. Hai nơi cùng định
   * nghĩa một khái niệm thì sớm muộn cũng lệch; giờ chỉ còn một nơi.
   */
  window.aeZoneForZip = function (zip) {
    try {
      const state = zipToState(zip);
      if (!state) return null;
      const key = resolveZoneKey(state, zip);
      const z = ZONES[key] || ZONES[FALLBACK_ZONE];
      return { zone: key, state: state, threshold: z.threshold, label: z.label, sub: z.sub, giao: z.giao !== false };
    } catch (e) { return null; }
  };

  resolve();
})();

;
